import { Component, EventEmitter, Injector, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DataService } from '@app/shared/common/auth/data.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/commonHelper/AppConsts';
import { AddFavoriteInput, AgendaServiceProxy, AttachmentServiceProxy, CommonAttachment, CopyMoveMsFileInputDto, CreateFileInputDto, CreateFileTask, CreateFolderDto, EntityType, FavoriteServiceProxy, FileParameter, LinkDto, LinkScope, LinkType, LinkServiceProxy, LookUpTables, OneDriveServiceProxy, TaskServiceProxy } from '@shared/service-proxies/service-proxies';
import { VfDriveDownloadService, DriveDownloadItem } from '@shared/utils/services/vf-drive-download.service';
import { VfFolderDropService, DroppedItem } from '@shared/utils/services/vf-folder-drop.service';
import { cloneDeep } from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { of, Subscription } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { ColDef, GridReadyEvent, GridApi, ColumnApi } from 'ag-grid-community';
import { guardGridFrameLoop } from '@app/main/shared/grid-frame-guard/grid-frame-guard';
import { VfModalShellComponent } from '@app/shared/common/components/modal-shell/vf-modal-shell.component';

type NsfMenuOption = {
  label: string;
  iconName?: string;
  callbackName?: string;
  action?: () => void;
  includeLibraryFlag?: boolean;
  isDanger?: boolean;
  cssClasses?: string[];
  subMenu?: Array<NsfMenuOption | 'separator'>;
};

@Component({
  selector: 'vf-navigate-sub-folders-modal',
  templateUrl: './navigate-sub-folders-modal.component.html'
})
export class NavigateSubFoldersModalComponent extends AppComponentBase implements OnInit, OnChanges {

  @ViewChild('navigateSubFoldersModal') modal: ModalDirective;
  @ViewChild('deleteMultipleFilesDeletePopup') deleteMultipleFilesDeletePopup: ModalDirective;
  @ViewChild('nestedDropdown', { static: false }) nestedDropdown: BsDropdownDirective;
  @ViewChild('copyDropdown', { static: false }) copyDropdown: BsDropdownDirective;
  @ViewChild('moveDropdown', { static: false }) moveDropdown: BsDropdownDirective;
  @ViewChild('errorShell') errorShell: VfModalShellComponent;
  @Input() cssClasses: string = 'task-modal-right';
  @Input() currentObj: any;
  @Input() needToClose: boolean = false;
  @Input() isRefreshItems: boolean = false;
  @Output() closeEmit: EventEmitter<any> = new EventEmitter<any>();
  isSaving = false;
  isLoading = false;
  isUploadFiles = false;
  isShowAddItem = false;
  noResultFound = false;
  isFolderEmpty = false;
  initialItem: any = {};
  driveItems: Array<any> = [];
  drives: Array<any> = [];
  selectedDocType = 1;
  itemBreadCrumb: any[] = [];
  level = 1;
  searchText = '';
  fileRawData: Array<any> = new Array<any>();
  fileErrorMsg = '';
  fileUploadError = false;
  delFileItem: any;
  selectedItem: any;
  isShowSelectAll = false;
  isAllItemsSelected = false;
  noOfSelectedItems = 0;
  subscription: Subscription;
  private moveCopyStartSub: Subscription;
  private moveCopyBadgeClearSub: Subscription;
  isDeleting = false;
  isShowAddLibrary = false;
  pattern = '^[^\\\\\\/\\:\\*\\?"\\<\\>\\|]+$';
  flNamePatternError = false;
  documentName = '';
  @ViewChild('fileNameInput') fileNameInput: any;
  isShowInfoPopup = false;
  information = '';
  nextBatchLink = '';
  isLoadingMore = false;
  isDragging = false;
  // While dragging device files OR rows inside the modal, this holds the folder/library
  // row that the pointer is currently hovering over (used for the blue row highlight +
  // "Drop here…" / "X files" hover badge). Null means "no row hover — current folder".
  dropTargetItem: any = null;
  // Same idea but for breadcrumb crumbs — holds the crumb (ancestor folder/library)
  // currently being hovered as a drop target. Mutually exclusive with dropTargetItem
  // in practice because the pointer can only be over one element at a time.
  breadcrumbDropTarget: any = null;
  // Source items captured at dragstart for an internal (intra-app) drag. Empty array
  // means the active drag is a device-file drag, not an internal one.
  internalDragItems: any[] = [];
  // Per-row in-flight operation tracker. Key is the row's lookup id (_tempId
  // when present, otherwise id). Value is the operation type so the cell can
  // render the right label ("Uploading…" / "Moving…").
  inFlightOps: Map<string, 'upload' | 'move' | 'copy' | 'create'> = new Map<string, 'upload' | 'move' | 'copy' | 'create'>();
  errorTitle = '';
  currentError: { message: string; cancelLabel?: string; saveLabel?: string } | undefined;
  private nsfConflictedUpload: { file: File; driveId: string; keyId: string | undefined } | null = null;
  private nsfUploadFinishCallback: ((wasSuccess: boolean) => void) | null = null;
  private _nsfFolderConflictResolve: ((saveAnyway: boolean) => void) | null = null;
  private _nsfMoveConflictQueue: Array<{
    errorCode: string;
    itemName: string;
    onRetry: (newName?: string) => void;
    onFinish: () => void;
  }> = [];
  private _nsfMoveConflictActive = false;
  private _nsfMoveConflictCurrent: {
    errorCode: string;
    itemName: string;
    onRetry: (newName?: string) => void;
    onFinish: () => void;
  } | null = null;
  private _nsfLastErrorCode: string | null = null;
  private _nsfPendingFolderInput: CreateFolderDto | null = null;
  private _nsfPendingFileInput: CreateFileInputDto | null = null;
  private _nsfConflictQueue: Array<{
    error: { message: string; cancelLabel?: string; saveLabel?: string };
    title: string;
    onSaveAnyway: (() => void) | null;
    onCancel: () => void;
  }> = [];
  private _nsfConflictQueueActive = false;
  private _nsfConflictQueueCurrent: { onSaveAnyway: (() => void) | null; onCancel: () => void } | null = null;
  activeSubmenu: string | null = null;
  userSectionData = [];
  sourceLabel = 'Files';
  override config = {
    swipeEasing: true,
    wheelPropagation: false,
    suppressScrollX: true
  };

  get hasCollapsedBreadcrumbs(): boolean {
    return this.itemBreadCrumb.length > 3;
  }

  get leadingBreadcrumb(): any | null {
    return this.hasCollapsedBreadcrumbs ? this.itemBreadCrumb[0] : null;
  }

  get collapsedBreadcrumbItems(): any[] {
    return this.hasCollapsedBreadcrumbs ? this.itemBreadCrumb.slice(1, -2) : [];
  }

  get trailingBreadcrumbItems(): any[] {
    return this.hasCollapsedBreadcrumbs ? this.itemBreadCrumb.slice(-2) : [];
  }

  get showSourceLabel(): boolean {
    return !!this.sourceLabel;
  }

  private _resolveSourceLabel(item: any): string {
    if (!item) {
      return 'Files';
    }

    if (item.sourceType === 'client' || item.sourceType === 'contact' || item.sourceType === 'company') {
      return '';
    }

    if (item.sourceType === 'task') {
      return item.from || 'Task';
    }

    if (item.sourceType === 'project') {
      return 'Project files';
    }

    return item.from || 'Files';
  }

  private _getCurrentTaskId(): number | null {
    if (this.initialItem?.sourceType !== 'task') {
      return null;
    }

    const rawTaskId = this.initialItem?.entityId ?? this.initialItem?.taskId;
    const taskId = Number(rawTaskId);
    return Number.isFinite(taskId) && taskId > 0 ? taskId : null;
  }

  private _canAddToCurrentTask(): boolean {
    return this._getCurrentTaskId() !== null;
  }

  trackByBreadcrumbItem(index: number, item: any): string {
    return `${item?.id ?? item?.name ?? 'breadcrumb'}-${index}`;
  }

  onRowClick(event: MouseEvent, item: any, isLibrary: boolean = false): void {
    // Don't trigger row action if click originated from the actions dropdown area
    const target = event.target as HTMLElement;
    if (target.closest('.dropdown')) {
      return;
    }
    if (isLibrary) {
      this.goToChildrenOfDrive(item);
    } else if (this.isShowSelectAll) {
      this.selectItem(item);
    } else if (item.extension === 'folder') {
      this.getDriveItems(item);
    } else {
      this.openLink(item);
    }
  }
  // AG Grid properties
  nsfGridApi: GridApi;
  nsfColumnApi: ColumnApi;
  nsfRowData: any[] = null;
  nsfColumnDefs: ColDef[] = [];
  nsfDefaultColDef: ColDef = {
    sortable: true,
    filter: false,
    resizable: true,
    suppressMenu: true
  };
  private _nsfMenuOpenRowId: string | null = null;
  private _nsfActionMenuCloseHandler: ((event: MouseEvent) => void) | null = null;

  constructor(injector: Injector,
    private dataService: DataService,
    private _linkService: LinkServiceProxy,
    private _agendaService: AgendaServiceProxy,
    private _oneDriveService: OneDriveServiceProxy,
    private _taskService: TaskServiceProxy,
    private _attachmentService: AttachmentServiceProxy,
    private _favoriteService: FavoriteServiceProxy,
    private _driveDownloadService: VfDriveDownloadService,
    private _folderDropService: VfFolderDropService,
    private _ngZone: NgZone) {
    super(injector);
  }

  private _toDriveDownloadItem(item: any): DriveDownloadItem | null {
    if (!item) return null;
    const keyId = item.id;
    const msDriveId = item.parentReference?.driveId || item.driveId;
    if (!keyId || !msDriveId) return null;
    const ext = (item.extension || '').toLowerCase();
    return {
      keyId,
      msDriveId,
      name: item.name,
      isFolder: ext === 'folder' || ext === 'documentlibrary' || !!item.folder
    };
  }

  downloadItem(item: any): void {
    // Document libraries are downloadable too — _toDriveDownloadItem maps them
    // to keyId === msDriveId === driveId (the library's id IS its drive's id),
    // and the backend's DownloadFolderZip / AddFolderToArchive route those
    // requests through Drives[driveId].Root instead of Items[driveId].
    const ref = this._toDriveDownloadItem(item);
    if (!ref) {
      const options = this.toastrOptions;
      this.toastr.error(`We couldn't download this file. Please try again.`, null, options);
      return;
    }
    this._driveDownloadService.downloadItems([ref]).subscribe({
      error: () => {
        const options = this.toastrOptions;
        this.toastr.error(`We couldn't download this file. Please try again.`, null, options);
      }
    });
  }

  downloadSelectedItems(): void {
    const selected = this.driveItems.filter(x => x.isSelected);
    if (selected.length === 0) {
      const options = this.toastrOptions;
      this.toastr.error('Please select at least one item to download.', null, options);
      return;
    }
    const refs: DriveDownloadItem[] = [];
    for (const item of selected) {
      const ref = this._toDriveDownloadItem(item);
      if (ref) refs.push(ref);
    }
    if (refs.length === 0) {
      const options = this.toastrOptions;
      this.toastr.error(`We couldn't download this file. Please try again.`, null, options);
      return;
    }
    this._driveDownloadService.downloadItems(refs).subscribe({
      error: () => {
        const options = this.toastrOptions;
        this.toastr.error(`We couldn't download this file. Please try again.`, null, options);
      }
    });
  }

  onNsfGridReady(params: GridReadyEvent) {
    this.nsfGridApi = params.api;
    this.nsfColumnApi = params.columnApi;
    // ag-Grid runs first-paint cell renderers on a frame queue that one throwing task used to stop for good,
    // leaving cells blank. See guardGridFrameLoop.
    guardGridFrameLoop(params.api);
    this.nsfColumnDefs = this._initNsfColumnDefs();
    setTimeout(() => {
      if (this.nsfGridApi) this.nsfGridApi.sizeColumnsToFit();
    }, 100);
    // Show loading if data is still being fetched
    if (this.isLoading || !this.nsfRowData) {
      params.api.showLoadingOverlay();
    } else if (this.nsfRowData.length === 0) {
      params.api.showNoRowsOverlay();
    }
  }

  updateNsfGridData() {
    const data = this.level === 1 ? this.driveItems : this.drives;
    this.nsfRowData = [...(data || [])];
    if (this.nsfGridApi) {
      this.nsfGridApi.hideOverlay();
      if (this.nsfRowData.length === 0) {
        if (this.isFolderEmpty || this.noResultFound) {
          this.nsfGridApi.showNoRowsOverlay();
        }
      }
      setTimeout(() => {
        if (this.nsfGridApi) this.nsfGridApi.sizeColumnsToFit();
      }, 100);
    }
  }

  showNsfGridLoading(clearData: boolean = true) {
    if (this.nsfGridApi) {
      if (clearData) {
        this.nsfRowData = null;
      }
      this.nsfGridApi.showLoadingOverlay();
    }
  }

  onNsfRowClicked(event: any) {
    if (!event || !event.data) return;
    if (event.column && (event.column.getColId() === 'selection' || event.column.getColId() === 'actions')) return;
    const item = event.data;
    const ext = (item.extension || '').toLowerCase();
    if (ext === 'documentlibrary') {
      this.goToChildrenOfDrive(item);
    } else if (ext === 'folder') {
      this.getDriveItems(item);
    } else {
      this.openLink(item);
    }
  }

  onNsfSelectionChanged() {
    if (!this.nsfGridApi) return;
    const selectedRows = this.nsfGridApi.getSelectedRows();
    this.noOfSelectedItems = selectedRows.length;
    // Sync ag-grid selection state back to driveItems/drives
    const selectedIds = new Set(selectedRows.map(r => r.id));
    const items = this.level === 1 ? this.driveItems : this.drives;
    items.forEach(item => {
      item.isSelected = selectedIds.has(item.id);
    });
  }

  refreshNsfGrid() {
    if (this.nsfGridApi) {
      this.nsfGridApi.setRowData(this.level === 1 ? this.driveItems : this.drives);
      this.nsfGridApi.sizeColumnsToFit();
    }
  }

  private _closeNsfActionMenu() {
    const el = document.getElementById('nsf-action-dropdown');
    if (el) el.remove();
    if (this._nsfActionMenuCloseHandler) {
      document.removeEventListener('mousedown', this._nsfActionMenuCloseHandler);
      this._nsfActionMenuCloseHandler = null;
    }
    this._nsfMenuOpenRowId = null;
  }

  private _findNsfItem(itemId: string, levelOneOnly = false): any {
    const items = levelOneOnly ? this.driveItems : (this.level === 1 ? this.driveItems : this.drives);
    return items.find(item => item._tempId === itemId || item.id === itemId);
  }

  private _getNsfMenuOptions(item: any, isLib: boolean): Array<NsfMenuOption | 'separator'> {
    const hasShare = !isLib && item?.parentReference?.driveId && item?.parentReference?.driveId !== item.id;
    const hasRename = !!item?.parentReference?.driveId || isLib;
    const options: Array<NsfMenuOption | 'separator'> = [
      {
        label: 'Open location',
        iconName: 'open',
        callbackName: '__nsfActionOpenLocation',
        action: () => this.openInM365(item)
      },
      'separator'
    ];

    if (!isLib) {
      options.push(
        {
          label: 'Add to task',
          iconName: 'add-task',
          callbackName: '__nsfActionAddToTask',
          action: () => this.openAddToTask(item)
        },
        {
          label: 'Add to project',
          iconName: 'add-project',
          callbackName: '__nsfActionAddToProject',
          action: () => this.openLinkToProject(item)
        }
      );
    }

    options.push(
      {
        label: 'Add to favorites',
        iconName: 'favorite',
        callbackName: '__nsfActionAddToFavorites',
        includeLibraryFlag: true,
        action: () => this.addFilesToShortcut(item, isLib)
      },
      {
        label: 'Add to my day',
        iconName: 'my-day',
        callbackName: '__nsfActionAddToMyDay',
        includeLibraryFlag: true,
        action: () => this.addFileTaskToMyDay(item, isLib, 0)
      }
    );

    if (!isLib && this._canAddToCurrentTask()) {
      options.push({
        label: 'Add to current task',
        iconName: 'add-task',
        callbackName: '__nsfActionAddToCurrentTask',
        action: () => this.addFileToCurrentTask(item)
      });
    }

    if (!isLib) {
      options.push(
        'separator',
        {
          label: 'Copy to',
          iconName: 'copy',
          subMenu: [
            {
              label: 'This location',
              callbackName: '__nsfActionCopyWithin',
              action: () => this.copyWithinThisFolder(item)
            },
            {
              label: 'Different location',
              callbackName: '__nsfActionCopyDifferent',
              action: () => this.copyToDiffLocation(item)
            }
          ]
        },
        {
          label: 'Move to',
          iconName: 'move',
          subMenu: [
            {
              label: 'This location',
              callbackName: '__nsfActionMoveWithin',
              action: () => this.moveWithinThisFolder(item)
            },
            {
              label: 'Different location',
              callbackName: '__nsfActionMoveDifferent',
              action: () => this.moveToDiffLocation(item)
            }
          ]
        }
      );
    }

    if (!isLib) {
      options.push(
        'separator',
        {
          label: 'Download',
          iconName: 'download',
          callbackName: '__nsfActionDownload',
          action: () => this.downloadItem(item)
        }
      );
    }

    options.push(
      'separator',
      {
        label: 'Copy URL only',
        iconName: 'copy-link',
        callbackName: '__nsfActionCopyLink',
        action: () => this.copyToClipboard(item.webUrl)
      }
    );

    if (hasShare) {
      options.push({
        label: 'Share',
        iconName: 'share',
        callbackName: '__nsfActionShare',
        action: () => this.openShareLinkModal(item)
      });
    }

    if (hasRename) {
      options.push({
        label: 'Rename',
        iconName: 'rename',
        callbackName: '__nsfActionRename',
        includeLibraryFlag: true,
        action: () => this.openRenameFileModal(item, isLib)
      });
    }

    // A document library is deletable too, but only when the owning site is known — the endpoint
    // needs it to resolve the SharePoint list behind the drive. Mirrors the project files explorer,
    // so the same library offers the same action on both screens.
    if (!isLib || !!(item?.msSiteId || item?.siteId)) {
      options.push(
        'separator',
        {
          label: 'Delete',
          iconName: 'delete',
          callbackName: '__nsfActionDelete',
          action: () => this.delFileItem = item,
          isDanger: true,
          cssClasses: ['ag-menu-option-delete']
        }
      );
    }

    return options;
  }

  private _registerNsfActionCallbacks() {
    (window as any).__nsfActionOpenLocation = (itemId: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId);
        if (item) this.openInM365(item);
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionAddToTask = (itemId: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId, true);
        if (item) this.openAddToTask(item);
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionAddToProject = (itemId: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId, true);
        if (item) this.openLinkToProject(item);
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionAddToFavorites = (itemId: string, isLibrary: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId);
        if (item) this.addFilesToShortcut(item, isLibrary === 'true');
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionAddToMyDay = (itemId: string, isLibrary: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId);
        if (item) this.addFileTaskToMyDay(item, isLibrary === 'true', 0);
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionAddToCurrentTask = (itemId: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId, true);
        if (item) this.addFileToCurrentTask(item);
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionCopyWithin = (itemId: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId, true);
        if (item) this.copyWithinThisFolder(item);
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionCopyDifferent = (itemId: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId, true);
        if (item) this.copyToDiffLocation(item);
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionMoveWithin = (itemId: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId, true);
        if (item) this.moveWithinThisFolder(item);
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionMoveDifferent = (itemId: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId, true);
        if (item) this.moveToDiffLocation(item);
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionCopyLink = (itemId: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId);
        if (item) this.copyToClipboard(item.webUrl);
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionDownload = (itemId: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId, true);
        if (item) this.downloadItem(item);
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionShare = (itemId: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId, true);
        if (item) this.openShareLinkModal(item);
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionRename = (itemId: string, isLibrary: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId);
        if (item) this.openRenameFileModal(item, isLibrary === 'true');
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionDelete = (itemId: string) => {
      this._ngZone.run(() => {
        const item = this._findNsfItem(itemId, true);
        if (item) this.delFileItem = item;
        this._closeNsfActionMenu();
      });
    };
    (window as any).__nsfActionToggleMenu = (itemId: string, btnEl: HTMLElement, isLibrary: string) => {
      if (this._nsfMenuOpenRowId === itemId) {
        this._closeNsfActionMenu();
        return;
      }
      this._closeNsfActionMenu();
      this._nsfMenuOpenRowId = itemId;
      const item = this._findNsfItem(itemId);
      if (!item) return;
      // Optimistic create/upload placeholder — the backing item isn't ready
      // yet (no real id/URL), so don't open its action menu.
      if (this._nsfIsRowPending(item)) { this._nsfMenuOpenRowId = null; return; }
      const isLib = isLibrary === 'true';
      const menuHtml = this._nsfMenuEntriesHtml(this._getNsfMenuOptions(item, isLib), itemId, isLib);

      const menu = document.createElement('div');
      menu.id = 'nsf-action-dropdown';
      menu.className = 'ag-ctx-menu nsf-action-menu';
      menu.innerHTML = menuHtml;
      document.body.appendChild(menu);
      menu.style.zIndex = '9999';
      const rect = btnEl.getBoundingClientRect();
      const menuW = Math.max(menu.offsetWidth || 0, 208);
      const menuH = menu.offsetHeight || 250;
      let top = rect.bottom + 4;
      let left = rect.right - menuW;
      if (left < 4) left = 4;
      if (top + menuH > window.innerHeight) top = rect.top - menuH - 4;
      menu.style.top = `${top}px`;
      menu.style.left = `${left}px`;
      this._nsfActionMenuCloseHandler = (e: MouseEvent) => {
        const target = e.target as Node;
        if (!menu.contains(target) && !btnEl.contains(target)) {
          this._closeNsfActionMenu();
        }
      };
      setTimeout(() => {
        if (this._nsfActionMenuCloseHandler) {
          document.addEventListener('mousedown', this._nsfActionMenuCloseHandler);
        }
      }, 0);
    };
  }

  private _nsfMenuIconSvg(iconName: string): string {
    switch (iconName) {
      case 'open':
        return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-icon"><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></svg>`;
      case 'add-task':
        return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-icon"><path d="M12 5v14"/><path d="M5 12h14"/></svg>`;
      case 'add-project':
        return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-icon"><rect width="20" height="14" x="2" y="7" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>`;
      case 'favorite':
        return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-icon"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`;
      case 'my-day':
        return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-icon"><circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/></svg>`;
      case 'copy':
        return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-icon"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg>`;
      case 'move':
        return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-icon"><path d="M8 3 4 7l4 4"></path><path d="M4 7h10a4 4 0 0 1 4 4v0"></path><path d="m16 21 4-4-4-4"></path><path d="M20 17H10a4 4 0 0 1-4-4v0"></path></svg>`;
      case 'copy-link':
        return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-icon"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>`;
      case 'share':
        return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-icon"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"/><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"/></svg>`;
      case 'rename':
        return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-icon"><path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"/></svg>`;
      case 'delete':
        return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-icon"><path d="M10 11v6"/><path d="M14 11v6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>`;
      case 'download':
        return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-icon"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/></svg>`;
      default:
        return '';
    }
  }

  private _nsfMenuEntriesHtml(options: Array<NsfMenuOption | 'separator'>, itemId: string, isLib: boolean): string {
    return options.map(option => option === 'separator'
      ? '<div class="ag-ctx-menu-separator"></div>'
      : this._nsfMenuItemHtml(option, itemId, isLib)).join('');
  }

  private _nsfMenuItemHtml(option: NsfMenuOption, itemId: string, isLib: boolean): string {
    if (option.subMenu && option.subMenu.length > 0) {
      return `<div class="ag-ctx-menu-item has-submenu">${option.iconName ? this._nsfMenuIconSvg(option.iconName) : ''}<span>${option.label}</span><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ag-ctx-menu-chevron"><path d="m9 18 6-6-6-6"></path></svg><div class="ag-ctx-submenu">${this._nsfMenuEntriesHtml(option.subMenu, itemId, isLib)}</div></div>`;
    }

    const args = [`'${itemId}'`];
    if (option.includeLibraryFlag) {
      args.push(`'${isLib}'`);
    }
    return `<div class="ag-ctx-menu-item${option.isDanger ? ' ag-ctx-menu-item--destructive' : ''}" onclick="window.${option.callbackName}(${args.join(',')})">${option.iconName ? this._nsfMenuIconSvg(option.iconName) : ''}<span>${option.label}</span></div>`;
  }

  private _toAgGridMenuItem(option: NsfMenuOption): any {
    if (option.subMenu && option.subMenu.length > 0) {
      return {
        name: option.label,
        icon: option.iconName ? this._nsfMenuIconSvg(option.iconName) : undefined,
        cssClasses: option.cssClasses,
        subMenu: option.subMenu.map(child => child === 'separator' ? 'separator' : this._toAgGridMenuItem(child))
      };
    }

    return {
      name: option.label,
      action: option.action,
      cssClasses: option.cssClasses,
      icon: option.iconName ? this._nsfMenuIconSvg(option.iconName) : undefined
    };
  }

  getContextMenuItems = (params: any) => {
    if (!params.node || !params.node.data) return [];
    const item = params.node.data;
    const ext = (item.extension || '').toLowerCase();
    const isLib = ext === 'documentlibrary';
    return this._getNsfMenuOptions(item, isLib).map(option => option === 'separator' ? 'separator' : this._toAgGridMenuItem(option));
  };

  /**
   * AG-Grid raises cellContextMenu on right-click before it shows its native
   * context menu. We hook it to dismiss any open row 3-dot menu so both
   * menus don't appear at the same time.
   */
  /**
   * True while a row is an optimistic create/upload placeholder — its `id` is
   * still a temporary `pending_…` id and the real OneDrive item (id, URL, etc.)
   * doesn't exist yet, so its action menu must stay closed.
   */
  private _nsfIsRowPending(item: any): boolean {
    return !!item && String(item.id || '').indexOf('pending_') === 0;
  }

  onNsfCellContextMenu(_event: any): void {
    if (this._nsfMenuOpenRowId) {
      this._closeNsfActionMenu();
    }
  }

  private _getFileIconHtml(ext: string): string {
    ext = (ext || '').toLowerCase();
    if (ext === 'folder') return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"/></svg>';
    if (ext === 'documentlibrary') return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"/></svg>';
    if (ext === 'doc' || ext === 'docx') return '<img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg" style="width:16px;height:16px;">';
    if (ext === 'xls' || ext === 'xlsx') return '<img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg" style="width:16px;height:16px;">';
    if (ext === 'ppt' || ext === 'pptx') return '<img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg" style="width:16px;height:16px;">';
    if (ext === 'pdf') return '<img src="https://cdn.trovve.com/trovve/pdf.png" style="width:16px;height:16px;">';
    if (ext === 'onenote') return '<img src="https://cdn.trovve.com/vfapp/images/file-icons/onenote.svg" style="width:16px;height:16px;">';
    return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/></svg>';
  }

  private _timeAgo(dateStr: string): string {
    if (!dateStr) return '—';
    const seconds = Math.floor((+new Date() - +new Date(dateStr)) / 1000);
    if (seconds < 29) return 'Just now';
    const intervals = [
      { s: 31536000, singular: 'year', plural: 'years' },
      { s: 2592000, singular: 'month', plural: 'months' },
      { s: 604800, singular: 'week', plural: 'weeks' },
      { s: 86400, singular: 'day', plural: 'days' },
      { s: 3600, singular: 'hour', plural: 'hours' },
      { s: 60, singular: 'minute', plural: 'minutes' },
      { s: 1, singular: 'second', plural: 'seconds' }
    ];
    for (const i of intervals) {
      const c = Math.floor(seconds / i.s);
      if (c > 0) return c + ' ' + (c === 1 ? i.singular : i.plural) + ' ago';
    }
    return '—';
  }

  private _initNsfColumnDefs(): ColDef[] {
    this._registerNsfActionCallbacks();
    this._registerNsfRowDragBridge();
    const isLibLevel = this.level === 2;
    const cols: ColDef[] = [];
    if (!isLibLevel) {
      cols.push({
        headerName: '',
        field: 'selection',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 44,
        maxWidth: 44,
        lockPosition: true,
        sortable: false,
        resizable: false,
        suppressMenu: true,
        colId: 'selection'
      });
    }
    cols.push(
      {
        headerName: 'Name',
        field: 'name',
        flex: 1,
        minWidth: 200,
        cellRenderer: (params: any) => {
          if (!params.data) return '';
          const item = params.data;
          const ext = (item.extension || '').toLowerCase();
          const isFolderLike = ext === 'folder' || ext === 'documentlibrary';
          const isLibrary = ext === 'documentlibrary';
          const lookupId = item._tempId || item.id;
          const op = this._rowInFlightOp(item);
          const inFlight = !!op;
          // File and folder rows are draggable. Libraries and in-flight rows
          // are not (libraries are top-level containers; an in-flight row is
          // already being moved/uploaded and can't be re-dragged).
          const iconHtml = this._getFileIconHtml(item.extension);
          const draggable = !isLibrary && !inFlight ? 'true' : 'false';
          const dragAttrs = draggable === 'true'
            ? `draggable="true" ondragstart="window.__nsfRowDragStart('${lookupId}',event)" ondragend="window.__nsfRowDragEnd()"`
            : '';
          // Inline status label rendered AFTER the file name (matches Figma).
          const inflightLabel = op
            ? `<span class="nsf-inflight-label" aria-live="polite"><span class="nsf-inflight-spinner-inline" aria-hidden="true"></span>${op === 'upload' ? 'Uploading…' : (op === 'copy' ? 'Copying…' : (op === 'create' ? 'Creating…' : 'Moving…'))}</span>`
            : '';
          const dropBadge = this.dropTargetItem === item && isFolderLike
            ? `<span class="nsf-drop-badge"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14"/><path d="m19 12-7 7-7-7"/></svg> ${this.dropTargetBadgeText}</span>`
            : '';
          const threeDotBtn = `<button class="ag-action-btn" style="flex-shrink:0"
              onclick="event.stopPropagation();window.__nsfActionToggleMenu('${lookupId}',this,'${isLibLevel}')">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg>
            </button>`;
          return `<div class="d-flex align-items-center gap-8 nsf-name-cell" style="height:100%;width:100%" ${dragAttrs}>`
            + `<span style="display:flex;flex-shrink:0">${iconHtml}</span>`
            + `<span class="f-size-14 text-gray-900 text-truncate" style="flex:1;min-width:0">${params.value || ''}</span>`
            + `${inflightLabel}${dropBadge}${threeDotBtn}</div>`;
        }
      },
      {
        headerName: 'Modified',
        field: 'modifiedDate',
        width: 140,
        // Sort on a numeric timestamp read from EITHER date field, not on the raw `modifiedDate`.
        // The cell already displays either one, but sorting used the field alone — and a document
        // library carries only `lastModifiedDateTime`, so every library row sorted as undefined,
        // compared equal, and clicking Modified left the list in its original order while the header
        // showed an active sort. Mirrors the same valueGetter in the project files explorer, whose
        // comment describes this for in-flight rows that seed `modifiedDate` only.
        valueGetter: (params: any) => {
          const raw = params.data?.modifiedDate || params.data?.lastModifiedDateTime;
          if (!raw) {
            return 0;
          }
          const ts = new Date(raw).getTime();
          return isNaN(ts) ? 0 : ts;
        },
        cellRenderer: (params: any) => {
          const dateStr = params.data?.modifiedDate || params.data?.lastModifiedDateTime;
          return `<span class="f-size-13 text-gray-500">${this._timeAgo(dateStr)}</span>`;
        }
      },
      {
        headerName: 'Modified by',
        field: 'modifiedBy',
        width: 140,
        cellRenderer: (params: any) => {
          const name = params.data?.modifiedBy || '—';
          return `<span class="f-size-13 text-gray-500">${name}</span>`;
        }
      },
      {
        headerName: 'Items',
        field: 'folder',
        width: 100,
        // Same as the project files explorer: `folder` is an object, so sorting on the field compared
        // {childCount: n} instances and produced no meaningful order. Sort on the number the cell
        // shows; rows with no count (files) return -1 so they group below "0 items".
        valueGetter: (params: any) => {
          const count = params.data?.folder?.childCount;
          return typeof count === 'number' ? count : -1;
        },
        cellRenderer: (params: any) => {
          if (!params.data) return '';
          const ext = (params.data.extension || '').toLowerCase();
          // childCount is nullable, so test for a number rather than for !== undefined: a JSON null
          // passes that older check and renders the literal string "null items".
          const count = params.data.folder?.childCount;
          if ((ext === 'folder' || ext === 'documentlibrary') && typeof count === 'number') {
            return `<span class="f-size-13 text-gray-500">${count} item${count === 1 ? '' : 's'}</span>`;
          }
          return '<span class="f-size-13 text-gray-500">—</span>';
        }
      }
    );
    return cols;
  }

  ngOnInit() {
    // refreshListAfterCopyOrMove is a shared Subject. Don't gate this
    // subscription on observers.length — when another modal is already
    // listening, this modal must still subscribe so it refreshes after a
    // copy/move triggered from inside it.
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.dataService.refreshListAfterCopyOrMove.subscribe(result => {
      // Clear any inline Move/Copy badges left over from picker-driven operations
      // — once the source list refreshes, moved rows are gone and remaining
      // items shouldn't keep their spinner.
      this._clearPickerInFlightOps();
      this.nsfGridApi?.redrawRows();
      if (this.selectedItem) {
        this.hideSelectAllBar();
        if (this.selectedItem.extension === 'documentLibrary') {
          this.goToChildrenOfDrive(this.selectedItem);
        } else {
          this.getDriveItems(this.selectedItem);
        }
      }
    });

    if (this.moveCopyBadgeClearSub) { this.moveCopyBadgeClearSub.unsubscribe(); }
    this.moveCopyBadgeClearSub = this.dataService.moveCopyBadgeClear.subscribe(() => {
      this._clearPickerInFlightOps();
      this.nsfGridApi?.redrawRows();
    });

    if (this.moveCopyStartSub) {
      this.moveCopyStartSub.unsubscribe();
    }
    // When the copy/move destination picker confirms a destination, mark the
    // selected source rows with the same inline spinner used by drag-drop so
    // the animation is visible (the picker closes immediately).
    this.moveCopyStartSub = this.dataService.moveCopyOperationStarted.subscribe(payload => {
      if (!payload || !payload.fileIds || payload.fileIds.length === 0) { return; }
      const idSet = new Set(payload.fileIds.map(id => String(id)));
      const op = payload.operation;
      let touched = false;
      for (const row of (this.driveItems || [])) {
        if (!row) continue;
        const rowId = String(row.id || '');
        if (idSet.has(rowId)) {
          const key = String(row._tempId || row.id);
          this.inFlightOps.set(key, op);
          touched = true;
        }
      }
      if (touched) {
        this.nsfGridApi?.redrawRows();
      }
    });

    document.addEventListener('dragenter', this.onDragEnter);
    document.addEventListener('dragleave', this.onDragLeave);
  }

  // Removes 'move' / 'copy' inflight marks the picker may have set — keeps
  // 'upload' marks intact since those are owned by the local upload flow.
  private _clearPickerInFlightOps(): void {
    if (!this.inFlightOps || this.inFlightOps.size === 0) { return; }
    const toDelete: string[] = [];
    this.inFlightOps.forEach((op, key) => {
      if (op === 'move' || op === 'copy') { toDelete.push(key); }
    });
    toDelete.forEach(k => this.inFlightOps.delete(k));
  }


  private _isDeviceFileDrag(e: DragEvent): boolean {
    const types = e.dataTransfer?.types;
    if (!types) { return false; }
    for (let i = 0; i < types.length; i++) {
      if (types[i] === 'Files') { return true; }
    }
    return false;
  }

  onDragEnter = (e: DragEvent) => {
    const draggingArea = document.querySelector('.dragging-area');
    if (draggingArea && draggingArea.contains(e.target as Node) && this._isDeviceFileDrag(e)) {
      this.isDragging = true;
    }
  };


  onDragLeave = (e: DragEvent) => {
    const draggingArea = document.querySelector('.dragging-area');
    if (draggingArea && !draggingArea.contains(e.relatedTarget as Node)) {
      this.isDragging = false;
      this.dropTargetItem = null;
    }
  };

  // Returns true if the item is a folder / document library that can accept drops.
  private _isFolderLikeRow(item: any): boolean {
    if (!item) { return false; }
    const ext = (item.extension || '').toLowerCase();
    return ext === 'folder' || ext === 'documentlibrary';
  }

  // Find the data row under a pointer event. Walks up to .ag-row then reads the
  // grid's displayed row at that index.
  private _rowDataFromEvent(e: DragEvent): any {
    if (!this.nsfGridApi) { return null; }
    const rowEl = (e.target as HTMLElement)?.closest('.ag-row') as HTMLElement | null;
    if (!rowEl) { return null; }
    const idxAttr = rowEl.getAttribute('row-index');
    if (idxAttr == null) { return null; }
    const node = this.nsfGridApi.getDisplayedRowAtIndex(parseInt(idxAttr, 10));
    return node?.data || null;
  }

  // dragover on the grid wrapper. Decides which folder row (if any) becomes the
  // current drop target so the row gets the blue highlight via getRowClass.
  onNsfGridDragOver(e: DragEvent) {
    const isDeviceDrag = this._isDeviceFileDrag(e);
    const isInternalDrag = this.internalDragItems.length > 0;
    if (!isDeviceDrag && !isInternalDrag) { return; }
    e.preventDefault();
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = isInternalDrag ? 'move' : 'copy';
    }
    const row = this._rowDataFromEvent(e);
    let newTarget = this._isFolderLikeRow(row) ? row : null;
    // Don't highlight a folder as a drop target if it's one of the items being
    // dragged (would result in a self-drop the move handler filters out anyway).
    if (newTarget && isInternalDrag) {
      const rowKey = newTarget._tempId || newTarget.id;
      if (this.internalDragItems.some(src => (src._tempId || src.id) === rowKey)) {
        newTarget = null;
      }
    }
    if (newTarget !== this.dropTargetItem) {
      this.dropTargetItem = newTarget;
      this.nsfGridApi?.redrawRows();
    }
  }

  onNsfGridDragLeave(e: DragEvent) {
    // Only clear if pointer actually left the grid wrapper.
    const wrapper = (e.currentTarget as HTMLElement);
    if (wrapper && wrapper.contains(e.relatedTarget as Node)) { return; }
    if (this.dropTargetItem) {
      this.dropTargetItem = null;
      this.nsfGridApi?.redrawRows();
    }
  }

  async onNsfGridDrop(e: DragEvent) {
    const isDeviceDrag = this._isDeviceFileDrag(e);
    const isInternalDrag = this.internalDragItems.length > 0;
    if (!isDeviceDrag && !isInternalDrag) { return; }
    e.preventDefault();
    e.stopPropagation();
    const target = this.dropTargetItem;
    this.dropTargetItem = null;
    this.isDragging = false;

    if (isDeviceDrag) {
      const dropped = await this._folderDropService.readDropEntries(e.dataTransfer);
      this.nsfGridApi?.redrawRows();
      if (dropped.length === 0) { return; }
      await this._handleNsfDroppedItems(dropped, target);
    } else if (isInternalDrag && target) {
      const items = this.internalDragItems.slice();
      this.internalDragItems = [];
      this._moveItemsToFolder(items, target);
      this.nsfGridApi?.redrawRows();
    } else {
      this.internalDragItems = [];
      this.nsfGridApi?.redrawRows();
    }
  }

  // Internal drag start (called from the Name cell renderer's draggable element).
  onInternalRowDragStart(e: DragEvent, item: any) {
    if (!item) { e.preventDefault(); return; }
    // Libraries are top-level containers and can't be moved.
    if ((item.extension || '').toLowerCase() === 'documentlibrary') {
      e.preventDefault();
      return;
    }
    const selected = (this.driveItems || []).filter(x => x.isSelected);
    // If the row is part of an active multi-selection, drag all selected items;
    // otherwise drag just this row.
    const isInSelection = selected.some(x => (x._tempId || x.id) === (item._tempId || item.id));
    this.internalDragItems = (isInSelection && selected.length > 0) ? selected.slice() : [item];
    if (e.dataTransfer) {
      e.dataTransfer.effectAllowed = 'move';
      // Some browsers refuse to start a drag without setData.
      try { e.dataTransfer.setData('application/x-nsf-item', String(item._tempId || item.id)); } catch {}
    }
  }

  onInternalRowDragEnd() {
    this.internalDragItems = [];
    if (this.dropTargetItem) {
      this.dropTargetItem = null;
      this.nsfGridApi?.redrawRows();
    }
    this.breadcrumbDropTarget = null;
  }

  // Breadcrumb crumbs become drop targets while a drag is in flight. Internal
  // drags move rows into the ancestor; device-file drags upload into it. The
  // current/last crumb is excluded — dropping there is equivalent to dropping
  // on the grid background and is already handled by onNsfGridDrop.
  isBreadcrumbDropActive(crumb: any): boolean {
    return !!crumb && !!this.breadcrumbDropTarget
      && (this.breadcrumbDropTarget === crumb || this.breadcrumbDropTarget.id === crumb.id);
  }

  onBreadcrumbDragOver(e: DragEvent, crumb: any) {
    const isDeviceDrag = this._isDeviceFileDrag(e);
    const isInternalDrag = this.internalDragItems.length > 0;
    if (!isDeviceDrag && !isInternalDrag) { return; }
    if (!crumb) { return; }
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = isInternalDrag ? 'move' : 'copy';
    }
    if (this.breadcrumbDropTarget !== crumb) {
      this.breadcrumbDropTarget = crumb;
    }
    // While hovering a crumb, suppress any grid-row highlight.
    if (this.dropTargetItem) {
      this.dropTargetItem = null;
      this.nsfGridApi?.redrawRows();
    }
  }

  onBreadcrumbDragLeave(e: DragEvent, crumb: any) {
    const related = e.relatedTarget as Node | null;
    const current = e.currentTarget as HTMLElement | null;
    if (current && related && current.contains(related)) { return; }
    if (this.breadcrumbDropTarget === crumb) {
      this.breadcrumbDropTarget = null;
    }
  }

  async onBreadcrumbDrop(e: DragEvent, crumb: any) {
    const isDeviceDrag = this._isDeviceFileDrag(e);
    const isInternalDrag = this.internalDragItems.length > 0;
    if (!isDeviceDrag && !isInternalDrag) { return; }
    if (!crumb) { return; }
    e.preventDefault();
    e.stopPropagation();
    this.breadcrumbDropTarget = null;
    this.isDragging = false;

    if (isDeviceDrag) {
      const dropped = await this._folderDropService.readDropEntries(e.dataTransfer);
      if (dropped.length === 0) { return; }
      await this._handleNsfDroppedItems(dropped, crumb);
    } else if (isInternalDrag) {
      const items = this.internalDragItems.slice();
      this.internalDragItems = [];
      this._moveItemsToFolder(items, crumb);
    }
  }

  // Routes between flat-files (existing flow) and folder-tree uploads.
  private async _handleNsfDroppedItems(items: DroppedItem[], targetFolder: any | null): Promise<void> {
    if (this._folderDropService.hasFolders(items)) {
      await this._uploadNsfFolderTree(items, targetFolder);
      return;
    }
    const files = items.map(i => i.file);
    this._handleDeviceFileDrop(files, targetFolder);
  }

  // Folder-tree upload: creates each sub-folder under the base destination
  // (parent-first), then uploads each file into the matching folder. Empty
  // and oversized leaf files are skipped (toast-summarized per reason) so a
  // single bad file doesn't abort the whole folder upload.
  private async _uploadNsfFolderTree(items: DroppedItem[], targetFolder: any | null): Promise<void> {
    if (!items.length) { return; }

    const filtered = this._folderDropService.filterValidUploadFiles(items, AppConsts.uploadFileSize);
    this._nsfToastSkippedFolderUploadFiles(filtered.skippedEmpty, filtered.skippedOversized);
    if (filtered.valid.length === 0) {
      this.toastr.error('No valid files to upload.', null, this.toastrOptions);
      return;
    }
    items = filtered.valid;

    // Resolve base destination (drive + parent folder id).
    let baseDriveId: string | undefined;
    let baseItemId: string | undefined;
    const resolveBase = (item: any) => {
      const ext = (item.extension || '').toLowerCase();
      if (ext === 'documentlibrary') {
        baseDriveId = item.id;
        baseItemId = undefined;
      } else {
        baseDriveId = item.parentReference?.driveId || item.driveId;
        baseItemId = item.id;
      }
    };
    if (targetFolder) {
      resolveBase(targetFolder);
    } else if (this.itemBreadCrumb.length > 0) {
      resolveBase(this.itemBreadCrumb[this.itemBreadCrumb.length - 1]);
    }
    if (!baseDriveId) {
      this.toastr.error('Could not resolve destination folder.', null, this.toastrOptions);
      return;
    }

    // Spinner on target folder row if a row-target was supplied.
    const targetKey = targetFolder ? String(targetFolder._tempId || targetFolder.id) : null;
    if (targetKey) {
      this.inFlightOps.set(targetKey, 'upload');
      this._redrawRowFor(targetFolder);
    }

    // When uploading into the current folder (no row target), insert an
    // optimistic placeholder row per top-level folder being uploaded so the
    // user sees the folder name with the "Uploading…" spinner in the list.
    // Cleared before the post-upload refresh repopulates the view.
    // Top-level folder names in this drop: the count the "uploading" toast below reports, and the
    // rows the placeholder block seeds. Hoisted out of the block so both can read it.
    const topLevelNames = Array.from(new Set(
      items.map(i => i.relativePath[0]).filter((n): n is string => !!n)
    ));

    const placeholderTempIds: string[] = [];
    if (!targetFolder) {
      for (const name of topLevelNames) {
        const tempId = this.addNewItemToGrid({
          id: 'pending_' + Date.now() + '_' + name,
          name,
          extension: 'folder',
          webUrl: '',
          modifiedDate: new Date().toISOString(),
          parentReference: { driveId: baseDriveId! },
          folder: { childCount: 0 },
          isSelected: false,
          isShow: true
        });
        this.inFlightOps.set(tempId, 'upload');
        placeholderTempIds.push(tempId);
      }
    }

    this.toastr.success(`We are uploading ${topLevelNames.length} folder${topLevelNames.length === 1 ? '' : 's'}. Please wait for a while.`, null, this.toastrOptions);

    // Map: path string → resolved folder coordinates ('' = base).
    const folderMap = new Map<string, { driveId: string, folderId: string }>();
    folderMap.set('', { driveId: baseDriveId!, folderId: baseItemId || '' });

    let folderCreateFailed = false;
    const paths = this._folderDropService.collectFolderPaths(items);
    for (const path of paths) {
      const parentKey = path.slice(0, -1).join('/');
      const parent = folderMap.get(parentKey);
      const folderName = path[path.length - 1];
      if (!parent) { folderCreateFailed = true; continue; }

      const input = new CreateFolderDto();
      input.name = folderName;
      input.driveId = parent.driveId;
      input.itemId = parent.folderId || '';
      input.isDocLibrary = false;
      input.isRename = false;
      input.folderType = this.itemBreadCrumb.length === 1 ? 1 : 3;

      try {
        const res = await this._oneDriveService.createFolder(input).toPromise();
        if (!res || res.isError || !res.responseData) {
          if (res?.errorMessage) {
            const errorDefinition = AppConsts.oneDriveErrors[res.errorMessage] ?? {message: res.errorMessage};
            if (errorDefinition?.saveLabel) {
              const saveAnyway = await this._nsfAskConflict(res.errorMessage, `Couldn't create this folder`);
              if (saveAnyway) {
                input.isUseExisting = true;
                try {
                  const retryRes = await this._oneDriveService.createFolder(input).toPromise();
                  if (retryRes && !retryRes.isError && retryRes.responseData) {
                    folderMap.set(path.join('/'), {
                      driveId: retryRes.responseData.driveId || parent.driveId,
                      folderId: retryRes.responseData.folderId || retryRes.responseData.driveId || ''
                    });
                    continue;
                  }
                } catch {}
              }
            } else {
              await this._nsfAskConflict(res.errorMessage, `Couldn't create this folder`);
            }
          }
          folderCreateFailed = true;
          continue;
        }
        folderMap.set(path.join('/'), {
          driveId: res.responseData.driveId || parent.driveId,
          folderId: res.responseData.folderId || res.responseData.driveId || ''
        });
      } catch {
        folderCreateFailed = true;
      }
    }

    // Upload each file into its resolved folder.
    let succeeded = 0;
    const failedNames: string[] = [];
    for (const item of items) {
      const folderInfo = folderMap.get(item.relativePath.join('/'));
      if (!folderInfo) { failedNames.push(item.file.name); continue; }
      const itemIdForUpload = folderInfo.folderId && folderInfo.folderId !== folderInfo.driveId
        ? folderInfo.folderId
        : undefined;
      try {
        const res = await this._oneDriveService.uploadFile(
          { data: item.file, fileName: item.file.name } as FileParameter,
          folderInfo.driveId,
          itemIdForUpload, 0
        ).toPromise();
        if (res && !res.isError && res.responseData) {
          succeeded++;
        } else {
          failedNames.push(item.file.name);
        }
      } catch {
        failedNames.push(item.file.name);
      }
    }

    if (targetKey) {
      this.inFlightOps.delete(targetKey);
      this._redrawRowFor(targetFolder);
    }
    for (const tempId of placeholderTempIds) {
      this.inFlightOps.delete(tempId);
      this.removeItemFromGrid(tempId);
    }

    if (failedNames.length === 0 && !folderCreateFailed) {
      this.toastr.success('Folder uploaded successfully.', null, this.toastrOptions);
    } else if (succeeded === 0) {
      this.toastr.error(`Couldn't upload the folder. Please try again.`, null, this.toastrOptions);
    } else {
      this.toastr.error(`Uploaded ${succeeded} of ${items.length} file${items.length === 1 ? '' : 's'}; ${failedNames.length} failed.`, null, this.toastrOptions);
    }

    // Refresh current view so the new folder + contents are visible.
    if (this.selectedItem) {
      if (this.selectedItem.extension === 'documentLibrary') {
        this.goToChildrenOfDrive(this.selectedItem);
      } else {
        this.getDriveItems(this.selectedItem);
      }
    }
  }

  // Computed badge text for the currently-hovered drop target (folder).
  // For device drag: "Drop here to upload in this folder."
  // For internal drag: "1 file" / "1 folder" / "N files" / "N folders" / "N items"
  // (mixed). Reflects what's actually being dragged so the user can verify before
  // dropping.
  get dropTargetBadgeText(): string {
    if (!this.dropTargetItem) { return ''; }
    if (this.internalDragItems.length > 0) {
      return this._formatDragItemsCount(this.internalDragItems);
    }
    return 'Drop here to upload in this folder.';
  }

  private _formatDragItemsCount(items: any[]): string {
    const folders = items.filter(i => this._isFolderLikeRow(i)).length;
    const files = items.length - folders;
    if (folders === 0) {
      return files === 1 ? '1 file' : `${files} files`;
    }
    if (files === 0) {
      return folders === 1 ? '1 folder' : `${folders} folders`;
    }
    return `${items.length} items`;
  }

  // Upload device-dropped files. If targetFolder is provided, upload INTO it
  // and show the "Uploading…" spinner on the *target folder row* (no phantom
  // placeholder in the current view). Otherwise upload to the current folder
  // (the deepest breadcrumb entry) using the existing placeholder flow.
  private _handleDeviceFileDrop(files: File[], targetFolder: any | null): void {
    if (targetFolder) {
      this._uploadFilesToSubfolder(files, targetFolder);
      return;
    }
    if (!this._nsfValidateFilesBeforeUpload(files)) {
      return;
    }
    this.fileRawData = files.slice();
    this.isUploadFiles = true;
    this.uploadFileToSpecificFolder(false, this.level, false);
  }

  // Toast helper for the folder-tree upload — surfaces skipped files (empty
  // or oversized) per reason, aggregated when there's more than one.
  private _nsfToastSkippedFolderUploadFiles(skippedEmpty: string[], skippedOversized: string[]): void {
    if (skippedEmpty.length === 1) {
      this.toastr.error(`"${skippedEmpty[0]}" is empty and can't be uploaded. Skipping.`, null, this.toastrOptions);
    } else if (skippedEmpty.length > 1) {
      this.toastr.error(`${skippedEmpty.length} files were empty and were skipped.`, null, this.toastrOptions);
    }
    if (skippedOversized.length === 1) {
      this.toastr.error(`"${skippedOversized[0]}" is too large to upload (max 25 MB). Skipping.`, null, this.toastrOptions);
    } else if (skippedOversized.length > 1) {
      this.toastr.error(`${skippedOversized.length} files were too large (max 25 MB) and were skipped.`, null, this.toastrOptions);
    }
  }

  // Pre-flight size / empty check used by the drag-drop entry point so the
  // request never reaches the server (a 25 MB+ upload times out at the
  // gateway and the missing CORS header on the timeout response triggers
  // the global abp error popup).
  private _nsfValidateFilesBeforeUpload(files: File[]): boolean {
    for (const f of files) {
      if (f.size >= AppConsts.uploadFileSize) {
        this.toastr.error(`"${f.name}" is too large to upload. Maximum size is 25 MB.`, null, this.toastrOptions);
        return false;
      }
      if (f.size === 0) {
        this.toastr.error(`"${f.name}" is empty and can't be uploaded.`, null, this.toastrOptions);
        return false;
      }
    }
    return true;
  }

  // Subfolder upload — marks the target folder row with the "Uploading…"
  // inline spinner instead of injecting a placeholder row in the current
  // view. Cleared when all per-file uploads settle.
  private _uploadFilesToSubfolder(files: File[], targetFolder: any): void {
    if (!files || files.length === 0 || !targetFolder) { return; }
    const targetExt = (targetFolder.extension || '').toLowerCase();
    const driveId = targetExt === 'documentlibrary'
      ? targetFolder.id
      : (targetFolder.parentReference?.driveId || targetFolder.driveId);
    const itemId = targetExt === 'documentlibrary' ? undefined : targetFolder.id;
    if (!driveId) {
      this.toastr.error('Could not resolve destination folder.', null, this.toastrOptions);
      return;
    }

    const oversized = files.find(f => f.size >= AppConsts.uploadFileSize);
    if (oversized) {
      this.toastr.error(`"${oversized.name}" is too large to upload. Maximum size is 25 MB.`, null, this.toastrOptions);
      return;
    }

    const targetKey = String(targetFolder._tempId || targetFolder.id);
    this.inFlightOps.set(targetKey, 'upload');
    this._redrawRowFor(targetFolder);

    this.toastr.success(`We are uploading ${files.length} file${files.length === 1 ? '' : 's'}. Please wait for a while.`, null, this.toastrOptions);
    let remaining = files.length;
    let succeeded = 0;
    const failedNames: string[] = [];
    const finish = () => {
      if (remaining > 0) { return; }
      this.inFlightOps.delete(targetKey);
      this._redrawRowFor(targetFolder);
      if (failedNames.length === 0) {
        this.toastr.success(`${files.length === 1 ? 'File' : 'Files'} uploaded successfully.`, null, this.toastrOptions);
      } else if (succeeded > 0) {
        this.toastr.error(`Uploaded ${succeeded} of ${files.length} file${files.length === 1 ? '' : 's'}; ${failedNames.length} failed.`, null, this.toastrOptions);
      }
      // all-failed: no toast — popup already notified user per file
    };

    files.forEach(file => {
      this._oneDriveService.uploadFile({ data: file, fileName: file.name } as FileParameter, driveId, itemId, 0).subscribe(result => {
        if (!result.isError && result.responseData) {
          remaining--;
          succeeded++;
          finish();
        } else {
          if (result.errorMessage) {
            const errorDefinition = result.errorMessage ? AppConsts.oneDriveErrors[result.errorMessage] : {message: result.errorMessage};
            this._nsfEnqueueConflict(
              errorDefinition,
              `Couldn't upload this file`,
              errorDefinition?.saveLabel ? () => {
                this._oneDriveService.uploadFile({ data: file, fileName: file.name } as FileParameter, driveId, itemId, 1).subscribe(
                  retryResult => {
                    remaining--;
                    if (!retryResult.isError && retryResult.responseData) { succeeded++; } else { failedNames.push(file.name); }
                    finish();
                  },
                  () => { remaining--; failedNames.push(file.name); finish(); }
                );
              } : null,
              () => { remaining--; failedNames.push(file.name); finish(); }
            );
          } else {
            remaining--;
            failedNames.push(file.name);
            finish();
          }
        }
      }, () => {
        remaining--;
        failedNames.push(file.name);
        finish();
      });
    });
  }

  // Intra-app move of files into a folder via OneDrive's moveMsFile endpoint.
  // Each in-flight row gets a spinner badge until the call returns; on success
  // the row is removed from the grid; once all in-flight calls finish, a
  // single summary toast is shown (so dragging N files spawns 1 toast rather
  // than N trickling in over time).
  private _moveItemsToFolder(items: any[], targetFolder: any): void {
    if (!items.length || !targetFolder) { return; }
    const toDriveId = targetFolder.parentReference?.driveId
      || (this._isFolderLikeRow(targetFolder) && targetFolder.extension?.toLowerCase() === 'documentlibrary' ? targetFolder.id : undefined)
      || targetFolder.driveId;
    const toItemId = this._isFolderLikeRow(targetFolder)
      && (targetFolder.extension || '').toLowerCase() === 'documentlibrary'
      ? undefined
      : targetFolder.id;
    const toSiteId = targetFolder.parentReference?.siteId || targetFolder.siteId;
    if (!toDriveId) {
      this.toastr.error('Could not resolve destination folder.', null, this.toastrOptions);
      return;
    }

    const dispatched = items.filter(src => {
      const fromDriveId = src.parentReference?.driveId || src.driveId;
      if (!fromDriveId || !src.id) { return false; }
      // Self-drop guard.
      if (toItemId && src.id === toItemId) { return false; }
      return true;
    });
    if (!dispatched.length) { return; }

    let pending = dispatched.length;
    let succeeded = 0;
    const failures: string[] = [];

    const finish = () => {
      if (pending > 0) { return; }
      const total = dispatched.length;
      if (succeeded === total) {
        const msg = total === 1
          ? `"${dispatched[0].name}" moved into "${targetFolder.name}".`
          : `${total} items moved into "${targetFolder.name}".`;
        this.toastr.success(msg, null, this.toastrOptions);
      } else if (succeeded === 0) {
        // popup already displayed the error — no toastr needed
      } else {
        this.toastr.error(`Moved ${succeeded} of ${total} items; ${failures.length} failed.`, null, this.toastrOptions);
      }
    };

    dispatched.forEach(src => {
      const fromDriveId = src.parentReference?.driveId || src.driveId;
      const fromSiteId = src.parentReference?.siteId || src.siteId;
      const rowKey = String(src._tempId || src.id);

      const input = new CopyMoveMsFileInputDto();
      input.fileId = src.id;
      input.fileName = src.name;
      input.fromDriveId = fromDriveId;
      input.fromSiteId = fromSiteId || undefined;
      input.toDriveId = toDriveId;
      input.toItemId = toItemId;
      input.toSiteId = toSiteId || undefined;
      input.duplicateAction = 0;
      input.requestFrom = 0;

      const tryMove = () => {
        this.inFlightOps.set(rowKey, 'move');
        this._redrawRowFor(src);
        this._oneDriveService.moveMsFile(input).subscribe({
          next: result => {
            this.inFlightOps.delete(rowKey);
            if (!result.isError) {
              this._removeRowByItem(src);
              succeeded++;
              pending--;
              finish();
            } else {
              this._redrawRowFor(src);
              if (result.errorMessage) {
                this._nsfMoveConflictQueue.push({
                  errorCode: result.errorMessage,
                  itemName: src.name,
                  onRetry: (newName?: string) => {
                    if (newName) { input.fileName = newName; input.duplicateAction = 0; }
                    tryMove();
                  },
                  onFinish: () => { failures.push(src.name); pending--; finish(); },
                });
                if (!this._nsfMoveConflictActive) { this._nsfDequeueMoveConflict(); }
                return;
              }
              failures.push(src.name);
              pending--;
              finish();
            }
          },
          error: () => {
            this.inFlightOps.delete(rowKey);
            this._redrawRowFor(src);
            failures.push(src.name);
            pending--;
            finish();
          }
        });
      };
      tryMove();
    });
  }

  // AG-Grid getRowClass callback — applied to the .ag-row element of each row.
  // Used to paint the blue drop-target highlight on whatever folder the cursor
  // is currently over, and a faded look on rows currently being moved/uploaded.
  getNsfRowClass = (params: any): string => {
    if (!params?.data) { return ''; }
    const classes: string[] = [];
    if (this.dropTargetItem && params.data === this.dropTargetItem) {
      classes.push('nsf-row-droptarget');
    }
    if (this._rowInFlightOp(params.data)) {
      classes.push('nsf-row-inflight');
    }
    return classes.join(' ');
  };

  // Resolve the active operation (if any) for a given row. Pending placeholder
  // rows whose id still starts with "pending_" count as an upload-in-progress
  // until the upload subscription clears that state.
  private _rowInFlightOp(data: any): 'upload' | 'move' | 'copy' | 'create' | null {
    if (!data) { return null; }
    const key = String(data._tempId || data.id);
    if (this.inFlightOps.has(key)) { return this.inFlightOps.get(key) || null; }
    if (String(data.id || '').startsWith('pending_')) { return 'upload'; }
    return null;
  }

  // True while the device-file drag cursor is hovering the drop strip itself
  // (used to switch the strip into its active blue style and swap the label).
  stripDragHover = false;

  onStripDragEnter(_e: DragEvent) {
    this.stripDragHover = true;
  }

  onStripDragLeave(e: DragEvent) {
    const strip = e.currentTarget as HTMLElement;
    const related = e.relatedTarget as Node | null;
    // Only clear when we actually leave the strip, not when crossing a child.
    if (!related || !strip.contains(related)) {
      this.stripDragHover = false;
    }
  }

  // Display name for the "Drop files to upload to <X>" strip.
  get currentFolderNameForDrop(): string {
    if (this.itemBreadCrumb.length > 0) {
      return this.itemBreadCrumb[this.itemBreadCrumb.length - 1]?.name || 'this folder';
    }
    return this.initialItem?.name || 'this folder';
  }

  // Drop on the "current folder" strip (when the user is not hovering a specific
  // folder row). Mirrors onNsfGridDrop's device-drag branch but always uploads
  // to the current breadcrumb folder.
  async onCurrentFolderDeviceDrop(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    this.isDragging = false;
    this.dropTargetItem = null;
    this.stripDragHover = false;
    const dropped = await this._folderDropService.readDropEntries(e.dataTransfer);
    if (dropped.length === 0) { return; }
    await this._handleNsfDroppedItems(dropped, null);
  }

  // Called from the Name cell's inline ondragstart/ondragend (cellRenderer
  // strings can't bind to component methods directly, so we register a window
  // bridge keyed by the row's lookup id).
  private _registerNsfRowDragBridge(): void {
    (window as any).__nsfRowDragStart = (lookupId: string, e: DragEvent) => {
      const item = this._findNsfItem(lookupId);
      if (item) { this.onInternalRowDragStart(e, item); }
    };
    (window as any).__nsfRowDragEnd = () => {
      this._ngZone.run(() => this.onInternalRowDragEnd());
    };
  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isRefreshItems && changes.isRefreshItems.currentValue) {
      if (this.selectedItem) {
        if (this.selectedItem.reqCallService) {
          if (this.selectedItem.reqCallService === 'getDrivesBySiteId') {
            this.goToDrivesBySiteId(this.selectedItem);
          }
        } else {
          if (this.selectedItem.extension === 'documentLibrary') {
            this.goToChildrenOfDrive(this.selectedItem);
          } else {
            this.getDriveItems(this.selectedItem);
          }
        }
      }
    }
    if (changes.needToClose && changes.needToClose.currentValue) {
      this.close();
    }
    if (changes.currentObj && changes.currentObj.currentValue) {
      this.clearObjs();
      this.show(changes.currentObj.currentValue);
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.moveCopyStartSub) {
      this.moveCopyStartSub.unsubscribe();
    }
    if (this.moveCopyBadgeClearSub) {
      this.moveCopyBadgeClearSub.unsubscribe();
    }
    this._closeNsfActionMenu();
  }

  goToChildrenOfDrive(drive, onSuccess?: () => void) {
    this.hideSelectAllBar();
    this.removeSearch();
    this.level = 1;
    if (this.nsfGridApi) this.nsfColumnDefs = this._initNsfColumnDefs();
    this.isLoading = true;
    this.showNsfGridLoading();
    this.isFolderEmpty = false;
    let index = this.itemBreadCrumb.findIndex(x => x.id === drive.id);
    if (index > -1) {
      // remove all items after the index
      this.itemBreadCrumb.splice(index + 1, this.itemBreadCrumb.length - index - 1);
    } else {
      this.itemBreadCrumb.push(drive);
    }
    let that = this;
    this.selectedItem = drive;
    // that._oneDriveService.getSharePointDriveChildrenByDriveId(drive.id).subscribe(result => {
    //   that.isLoading = false;
    //   if (!result.isError) {
    //     that.driveItems = [];
    //     if (result.responseData.length > 0) {
    //       that.driveItems = result.responseData;
    //       that.driveItems.forEach(element => {
    //         element.isSelected = false;
    //         element.isShow = true;
    //       });
    //     } else {
    //       that.isFolderEmpty = true;
    //     }
    //   }
    // });

    this.nextBatchLink = '';
    that._oneDriveService.getMsFiles(drive.id, undefined, undefined, undefined).subscribe(result => {
      that.isLoading = false;
      if (!result.isError) {
        that.driveItems = [];
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            that.driveItems = result.responseData['item1'];
            that.driveItems.forEach(element => {
              element.isSelected = false;
              element.isShow = true;
            });
          } else {
            this.isFolderEmpty = true;
          }
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
        onSuccess?.();
      } else {
        const errorDef = result.errorMessage ? AppConsts.oneDriveErrors[result.errorMessage] : {message: result.errorMessage};
        this.errorTitle = "Couldn't load files";
        this.currentError = errorDef;
        this.errorShell.show();
      }
      that.updateNsfGridData();
    });

  }

  getDriveItems(item, onSuccess?: () => void) {
    this.hideSelectAllBar();
    this.removeSearch();
    this.level = 1;
    if (this.nsfGridApi) this.nsfColumnDefs = this._initNsfColumnDefs();
    // check if item is already in the itemBreadCrumb
    let index = this.itemBreadCrumb.findIndex(x => x.id === item.id);
    if (index > -1) {
      // remove all items after the index
      this.itemBreadCrumb.splice(index + 1, this.itemBreadCrumb.length - index - 1);
    } else {
      this.itemBreadCrumb.push(item);
    }
    this.isLoading = true;
    this.showNsfGridLoading();
    this.isFolderEmpty = false;
    let that = this;
    that.selectedItem = item;
    // that._oneDriveService.getDriveItemsByItemId(item.parentReference.driveId, item.id).subscribe(result => {
    //   that.isLoading = false;
    //   if (!result.isError) {
    //     that.driveItems = [];
    //     if (result.responseData.length > 0) {
    //       that.driveItems = result.responseData;
    //       that.driveItems.forEach(element => {
    //         element.isSelected = false;
    //         element.isShow = true;
    //       });
    //     } else {
    //       that.isFolderEmpty = true;
    //     }
    //   }
    // });

    this.nextBatchLink = '';
    that._oneDriveService.getMsFiles(item.parentReference.driveId, item.parentReference.driveId === item.id ? undefined : item.id, undefined, undefined).subscribe(result => {
      that.isLoading = false;
      if (!result.isError) {
        that.driveItems = [];
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            that.driveItems = result.responseData['item1'];
            that.driveItems.forEach(element => {
              element.isSelected = false;
              element.isShow = true;
            });
          } else {
            this.isFolderEmpty = true;
          }
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
        onSuccess?.();
      } else {
        const errorDef = result.errorMessage ? AppConsts.oneDriveErrors[result.errorMessage] : {message: result.errorMessage};
        this.errorTitle = "Couldn't load files";
        this.currentError = errorDef;
        this.errorShell.show();
      }
      that.updateNsfGridData();
    });
  }

  getMoreMyFiles(event?: any) {
    if (this.nextBatchLink !== '' && !this.isLoading && !this.isLoadingMore && this.level === 1) {
      let input: any = {};
      if (this.selectedItem.extension === 'documentLibrary') {
        input.driveId = this.selectedItem.id;
        input.id = undefined;
      } else {
        input.driveId = this.selectedItem.parentReference.driveId;
        input.id = this.selectedItem.id;
      }
      this.isLoadingMore = true;
      this._oneDriveService.getMsFiles(input.driveId, input.driveId === input.id ? undefined : input.id, this.nextBatchLink, undefined).subscribe(result => {
        this.isLoadingMore = false;
        if (!result.isError) {
          if (result.responseData) {
            const newItems = result.responseData['item1'] || [];
            if (newItems.length > 0) {
              newItems.forEach(element => {
                element.isSelected = false;
                element.isShow = true;
              });
              this.driveItems.push(...newItems);
              // Append rows without resetting scroll
              if (this.nsfGridApi) {
                this.nsfGridApi.applyTransaction({ add: newItems });
              }
            }
            if (result.responseData['item2']) {
              this.nextBatchLink = result.responseData['item2'];
            } else {
              this.nextBatchLink = '';
            }
          }
        } else {
          const errorDef = result.errorMessage ? AppConsts.oneDriveErrors[result.errorMessage] : {message: result.errorMessage};
          this.errorTitle = "Couldn't load files";
          this.currentError = errorDef;
          this.errorShell.show();
        }
      });
    }
  }

  private addNewItemToGrid(item: any): string {
    const userName = this.appSession.user
      ? ((this.appSession.user.name || '') + ' ' + (this.appSession.user.surname || '')).trim()
      : '';
    item.modifiedBy = userName;
    if (!item._tempId) {
      item._tempId = 'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    }
    this.driveItems.unshift(item);
    if (this.nsfGridApi) {
      this.nsfGridApi.applyTransaction({ add: [item], addIndex: 0 });
    }
    this.isShowAddItem = false;
    this.isShowAddLibrary = false;
    return item._tempId;
  }

  private removeItemFromGrid(tempId: string) {
    const idx = this.driveItems.findIndex(i => i._tempId === tempId);
    if (idx > -1) {
      const removed = this.driveItems.splice(idx, 1);
      if (this.nsfGridApi && removed.length > 0) {
        this.nsfGridApi.applyTransaction({ remove: removed });
      }
    }
  }

  // Force AG-Grid to re-render a single row so the cell renderer picks up
  // changes in inFlightOps / pending state. Falls back to a full redraw if
  // the node lookup fails.
  private _redrawRowFor(item: any) {
    if (!this.nsfGridApi || !item) { return; }
    let node: any = null;
    this.nsfGridApi.forEachNode((n: any) => {
      if (node) { return; }
      if (n.data === item) { node = n; return; }
      if (item._tempId && n.data?._tempId === item._tempId) { node = n; return; }
      if (item.id != null && n.data?.id === item.id) { node = n; return; }
    });
    if (node) {
      this.nsfGridApi.redrawRows({ rowNodes: [node] });
    } else {
      this.nsfGridApi.redrawRows();
    }
  }

  // Remove a row by reference (matching either _tempId or id) — used after an
  // intra-app move so the row disappears from the source folder.
  private _removeRowByItem(item: any) {
    if (!item) { return; }
    const idx = this.driveItems.findIndex(i => i === item
      || (item._tempId && i._tempId === item._tempId)
      || (item.id != null && i.id === item.id));
    if (idx > -1) {
      const removed = this.driveItems.splice(idx, 1);
      if (this.nsfGridApi && removed.length > 0) {
        this.nsfGridApi.applyTransaction({ remove: removed });
      }
    }
  }

  onNsfBodyScroll(event: any) {
    if (!event || !this.nsfGridApi) return;
    if (event.direction !== 'vertical') return;
    // Only trigger near the very bottom, and not if already loading or no more data
    if (this.nextBatchLink === '' || this.isLoadingMore || this.isLoading || this.level !== 1) return;
    const gridBody = this.nsfGridApi.getVerticalPixelRange();
    const totalHeight = this.nsfGridApi.getDisplayedRowCount() * 44; // rowHeight
    const viewportBottom = gridBody.bottom;
    if (viewportBottom >= totalHeight - 100) {
      this.getMoreMyFiles();
    }
  }

  show(item) {
    this.nsfColumnDefs = this._initNsfColumnDefs();
    this.initialItem = item;
    let tmpName = cloneDeep(item.from);
    this.initialItem.fromTruncated = tmpName;
    this.sourceLabel = this._resolveSourceLabel(item);
    if (item) {
      let driveId = '';
      let itemId = '';
      let siteId = item.msSiteId || item.siteId || undefined;
      const openSlider = () => {
        $('body').addClass('task-modal-body');
        this.modal.show();
        this.getUserSections();
      };
      if (item.reqCallService) {
        if (item.reqCallService === 'getDrivesBySiteId') {
          this.goToDrivesBySiteId(item);
          openSlider();
        }
      } else {
        const fetchBreadcrumb = (bcDriveId: string, bcItemId: string, bcSiteId: string) => {
          if (!bcDriveId) { return; }
          this._oneDriveService.getFolderBreadcrumb(bcDriveId, bcItemId || undefined, bcSiteId).subscribe(result => {
            if (!result.isError && result.responseData) {
              const bcItems = [];
              result.responseData.forEach(bc => {
                if (bc.type === 'site') {
                  bcItems.push({ id: bc.id, name: bc.name, displayName: bc.name, reqCallService: 'getDrivesBySiteId', bcType: 'site' });
                } else if (bc.type === 'documentLibrary') {
                  bcItems.push({ id: bc.driveId, name: bc.name, extension: 'documentLibrary', bcType: 'documentLibrary' });
                } else if (bc.type === 'folder') {
                  bcItems.push({ id: bc.id, name: bc.name, extension: 'folder', parentReference: { driveId: bc.driveId }, bcType: 'folder' });
                }
              });
              this.itemBreadCrumb = bcItems;
            }
          });
        };
        // Open the window FIRST, then fetch. openSlider used to be the fetch's completion callback, so
        // clicking a folder did nothing visible until the OneDrive round-trip came back — on a slow drive
        // that is seconds of no feedback, and it reads as the click not registering. Both fetch methods
        // already set isLoading and show the grid's loading overlay; that state was simply never on screen
        // to be seen. The callback now carries only the breadcrumb, which genuinely does need the data.
        this.isLoading = true;
        this.nsfRowData = null;
        openSlider();
        if (item.extension === 'documentLibrary') {
          let input = item;
          input.id = item.keyId;
          driveId = input.id;
          this.goToChildrenOfDrive(input, () => { fetchBreadcrumb(driveId, itemId, siteId); });
        } else {
          let input = cloneDeep(item);
          input.id = item.keyId;
          input.parentReference = {};
          input.parentReference.driveId = item.driveId ? item.driveId : item.parentReference.driveId;
          driveId = input.parentReference.driveId;
          itemId = input.id;
          this.getDriveItems(input, () => { fetchBreadcrumb(driveId, itemId, siteId); });
        }
      }
    }
    setTimeout(() => {
      this.initializeSearch();
    }, 100);
  }

  goToDrivesBySiteId(site) {
    this.isShowAddLibrary = false;
    this.hideSelectAllBar();
    this.removeSearch();
    this.level = 2;
    if (this.nsfGridApi) this.nsfColumnDefs = this._initNsfColumnDefs();
    this.isLoading = true;
    this.showNsfGridLoading();
    this.isFolderEmpty = false;
    let index = this.itemBreadCrumb.findIndex(x => x.id === site.id);
    if (index > -1) {
      // remove all items after the index
      this.itemBreadCrumb.splice(index + 1, this.itemBreadCrumb.length - index - 1);
    } else {
      let itm = cloneDeep(site);
      itm.name = itm.displayName;
      this.itemBreadCrumb.push(itm);
    }
    let that = this;
    this.selectedItem = site;
    that._oneDriveService.getDrivesBySiteId(site.id).subscribe(result => {
      that.isLoading = false;
      if (!result.isError) {
        that.drives = [];
        if (result.responseData.length > 0) {
          that.drives = result.responseData;
          that.drives.forEach(element => {
            element.extension = element.extension ? element.extension : 'documentLibrary';
            element.isSelected = false;
            element.isShow = true;
            // Stamp the owning site onto the row. A Graph `drive` payload carries no site id of its
            // own (and no parentReference either), so the only source is the id we just queried with.
            // Delete needs it twice over: to decide whether to offer the action, and to resolve the
            // SharePoint list behind the drive when it runs. The project files explorer gets this from
            // normalizeProjectFilesExplorerItem's siteId argument; this path had no equivalent.
            element.msSiteId = element.msSiteId || site.id;
            // The Modified by cell binds a FLAT `modifiedBy`. Rows from GetMsFiles arrive with one
            // already, but a drive carries Graph's nested identitySet instead, so without this the
            // column showed an em-dash for every library. Same flattening the project files
            // explorer does; createdBy is the fallback Graph uses when nothing has modified the
            // library since it was created.
            element.modifiedBy = element.modifiedBy
              || element.lastModifiedBy?.user?.displayName
              || element.createdBy?.user?.displayName
              || '';
          });
        } else {
          that.isFolderEmpty = true;
        }
      }
      that.updateNsfGridData();
    });
  }

  close() {
    if (this.modal && this.modal.isShown) {
      this.clearObjs();
      this.modal.hide();
      this.closeEmit.emit();
    }
  }

  private clearObjs() {
    this.driveItems = [];
    this.drives = [];
    this.selectedItem = undefined;
    this.itemBreadCrumb = [];
    this.searchText = '';
    this.noResultFound = false;
    this.isFolderEmpty = false;
    this.isUploadFiles = false;
    this.isShowAddItem = false;
    this.initialItem = {};
    this.selectedDocType = 1;
    this.isLoading = false;
    this.isShowSelectAll = false;
    this.noOfSelectedItems = 0;
    this.isShowAddLibrary = false;
  }

  showAddItem(type) {
    this.isShowAddItem = true;
    this.selectedDocType = type;
    this.documentName = '';
    setTimeout(() => {
      const input = document.getElementById('create-file-input') as HTMLInputElement;
      if (input) input.focus();
    }, 100);
  }

  selectDocType(type) {
    this.selectedDocType = type;
  }

  onNewFileKeyPress(event: any, isOneDrive, level): boolean {
    if (event.keyCode === 13) {
      this.createFile(event, isOneDrive, level);
    }
    return event.keyCode !== 13;
  }

  onNewFileBlur(event: any, isOneDrive, level) {
    this.createFile(event, isOneDrive, level);
    setTimeout(() => {
      this.documentName = '';
    }, 500);
    this.isShowAddItem = false;
  }

  createFile(event, isOneDrive, level): void {
    if (this.fileNameInput.errors && this.fileNameInput.errors.pattern) {
      this.flNamePatternError = true;
      return;
    }
    // let value: string = event.target.innerText.trim();
    // if (value.length === 0) {
    //   let value = this.documentName.trim();
    // }
    let value = this.documentName.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    if (this.isSaving) {
      return;
    }
    let input: CreateFileInputDto = new CreateFileInputDto();
    input.isShareFile = true;
    input.isOneNote = this.selectedDocType === 4 ? true : false;
    input.name = value.trim();
    if (this.selectedDocType === 1) {
      input.extension = '.docx';
    } else if (this.selectedDocType === 2) {
      input.extension = '.xlsx';
    } else if (this.selectedDocType === 3) {
      input.extension = '.pptx';
    }
    // this.fileNameError = false;
    // this.fileNameErrorMessage = '';
    if (this.itemBreadCrumb.length > 0) {
      let item = this.itemBreadCrumb[this.itemBreadCrumb.length - 1];
      input.itemId = '';
      input.driveId = '';
      if (item.extension === 'documentLibrary') {
        input.driveId = item.id;
      } else {
        input.itemId = item.id;
        input.driveId = item.parentReference.driveId;
      }
      this.isSaving = true;
      this.documentName = '';
      if (input.itemId === input.driveId) { input.itemId = undefined; }
      const ext = input.extension ? input.extension.replace('.', '') : '';
      const tempId = this.addNewItemToGrid({
        id: 'pending_' + Date.now(),
        name: input.name + (input.extension || ''),
        extension: ext,
        webUrl: '',
        modifiedDate: new Date().toISOString(),
        parentReference: { driveId: input.driveId },
        isSelected: false,
        isShow: true
      });
      // Show the "Creating…" spinner on the optimistic row while the API runs.
      this.inFlightOps.set(tempId, 'create');
      this._oneDriveService.createOneDriveFile(input).subscribe(result => {
        this.isSaving = false;
        this.inFlightOps.delete(tempId);
        if (!result.isError && result.responseData) {
          // Update the optimistic item with real data
          const item = this.driveItems.find(i => i._tempId === tempId);
          if (item) {
            item.id = result.responseData.keyId;
            item.name = result.responseData.fileName || item.name;
            item.webUrl = result.responseData.url;
            item.parentReference = { driveId: result.responseData.driveId || input.driveId, siteId: result.responseData.siteId };
            // Repaint the row so the spinner badge clears now that the
            // real id is set; without this the badge sticks and overrides
            // the 'Moving…' label when the user later drags this row.
            this._redrawRowFor(item);
          }
          let options = this.toastrOptions;
          this.toastr.success('File created successfully.', null, options);
        } else {
          this.removeItemFromGrid(tempId);
          if (result.errorMessage) {
            const errorDefinition = result.errorMessage ? AppConsts.oneDriveErrors[result.errorMessage] : {message: result.errorMessage};
            this.currentError = errorDefinition;
            this._nsfLastErrorCode = result.errorMessage;
            this.errorTitle = `Couldn't create this file`;
            if (errorDefinition?.saveLabel) {
              this._nsfPendingFileInput = input;
            }
            this.errorShell.show();
          }
        }
      }, () => {
        this.isSaving = false;
        this.inFlightOps.delete(tempId);
        this.removeItemFromGrid(tempId);
      });
    }
  }

  okInfoPopupClicked(ev: any) {
    this.isShowInfoPopup = false;
  }

  onNewFolderKeyPress(event: any, isOneDrive, level): boolean {
    if (event.keyCode === 13) {
      this.createFolder(event, isOneDrive, level);
    }
    return event.keyCode !== 13;
  }

  onNewFolderBlur(event: any, isOneDrive, level) {
    this.createFolder(event, isOneDrive, level);
    setTimeout(() => {
      this.documentName = '';
    }, 500);
    this.isShowAddItem = false;
  }

  createFolder(event, isOneDrive, level): void {
    if (this.fileNameInput.errors && this.fileNameInput.errors.pattern) {
      this.flNamePatternError = true;
      return;
    }
    // let value: string = event.target.innerText.trim();
    let value = this.documentName.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    if (this.isSaving) {
      return;
    }
    let input: CreateFolderDto = new CreateFolderDto();
    input.isDocLibrary = false;
    input.isRename = false;
    input.name = value.trim();
    // this.fileNameError = false;
    // this.fileNameErrorMessage = '';
    if (this.itemBreadCrumb.length > 0) {
      let item = this.itemBreadCrumb[this.itemBreadCrumb.length - 1];
      input.itemId = '';
      input.driveId = '';
      if (item.extension === 'documentLibrary') {
        input.driveId = item.id;
      } else {
        input.itemId = item.id;
        input.driveId = item.parentReference.driveId;
      }
      input.folderType = this.itemBreadCrumb.length === 1 ? 1 : 3;
      this.isSaving = true;
      this.documentName = '';
      const tempId = this.addNewItemToGrid({
        id: 'pending_' + Date.now(),
        name: input.name,
        extension: 'folder',
        webUrl: '',
        modifiedDate: new Date().toISOString(),
        parentReference: { driveId: input.driveId },
        folder: { childCount: 0 },
        isSelected: false,
        isShow: true
      });
      this.inFlightOps.set(tempId, 'create');
      this._oneDriveService.createFolder(input).subscribe(result => {
        this.isSaving = false;
        this.inFlightOps.delete(tempId);
        if (!result.isError && result.responseData) {
          const item = this.driveItems.find(i => i._tempId === tempId);
          if (item) {
            item.id = result.responseData.folderId || result.responseData.driveId;
            item.webUrl = result.responseData.folderUrl || '';
            item.parentReference = { driveId: result.responseData.driveId || input.driveId, siteId: result.responseData.siteId };
            this._redrawRowFor(item);
          }
          let options = this.toastrOptions;
          this.toastr.success('Folder created successfully.', null, options);
        } else {
          this.removeItemFromGrid(tempId);
          if (result.errorMessage) {
            const errorDefinition = result.errorMessage ? AppConsts.oneDriveErrors[result.errorMessage] : {message: result.errorMessage};
            this.currentError = errorDefinition;
            this._nsfLastErrorCode = result.errorMessage;
            this.errorTitle = `Couldn't create this folder`;
            if (errorDefinition?.saveLabel) {
              this._nsfPendingFolderInput = input;
            }
            this.errorShell.show();
          }
        }
      }, () => {
        this.isSaving = false;
        this.inFlightOps.delete(tempId);
        this.removeItemFromGrid(tempId);
      });
    }
  }

  triggerFileControl(): void {
    $('#fileUploadOneDrive_Navigate').trigger('click');
  }

  onSelect(event: any, level) {
    setTimeout(() => {
      this.isDragging = false;
    }, 100);
    // Handle the files (e.g., upload, preview)
    let e = {};
    e['target'] = {};
    e['target']['files'] = event.addedFiles;
    // this.fileInputChanged(e, false, level);
    if (event.addedFiles) {
      let files = [];
      files = event.addedFiles;
      this.fileRawData = [];
      let fileCts = event.addedFiles.length;
      for (let index = 0; index < event.addedFiles.length; index++) {
        const element = event.addedFiles[index];
        this.fileUploadError = false;
        let file = element;
        this.fileRawData.push(file);
        fileCts--;
        if (fileCts <= 0) {
          this.isUploadFiles = true;
          this.uploadFileToSpecificFolder(false, level);
        }
      }
    }
  }

  fileInputChanged(event, isOneDrive, level): void {
    let that = this;
    if (event.target.value) {
      if (event.target.files) {
        let files = [];
        files = event.target.files;
        if (event.target.files.length > 0) {
          // Surface a toast for oversized / empty files so the picker UX
          // matches drag-drop, then bail before kicking off the upload.
          let validationFailed = false;
          for (let index = 0; index < event.target.files.length; index++) {
            const element = event.target.files[index];
            if (element.size >= AppConsts.uploadFileSize) {
              that.toastr.error(`"${element.name}" is too large to upload. Maximum size is 25 MB.`, null, that.toastrOptions);
              validationFailed = true;
            } else if (element.size === 0) {
              that.toastr.error(`"${element.name}" is empty and can't be uploaded.`, null, that.toastrOptions);
              validationFailed = true;
            }
          }
          if (validationFailed) {
            (event.target as HTMLInputElement).value = '';
            return;
          }
          that.fileRawData = [];
          if (!that.fileUploadError) {
            let fileCts = event.target.files.length;
            for (let index = 0; index < event.target.files.length; index++) {
              const element = event.target.files[index];
              that.fileUploadError = false;
              let file = element;
              that.fileRawData.push(file);
              fileCts--;
              if (fileCts <= 0) {
                that.isUploadFiles = true;
                that.uploadFileToSpecificFolder(isOneDrive, level);
                event.target.value = null;
              }
            }
          } else {
            that.fileUploadError = false;
          }
        }
      }
    }
  }

  uploadFileToSpecificFolder(isOneDrive, level, removeOnSuccess: boolean = false) {
    if (this.fileRawData.length > 0) {
      let fileCts = this.fileRawData.length;
      // Captured up front for the completion toasts' singular/plural: fileRawData can be mutated
      // during the upload (removeOnSuccess), so its .length is not the batch total by the time
      // those toasts fire.
      const totalFiles = fileCts;
      let options = this.toastrOptions;
      this.toastr
        .success(`We are uploading ${totalFiles} file${totalFiles === 1 ? '' : 's'}. Please wait for a while.`,
          null, options);
      let that = this;
      this.fileRawData.forEach((element, index) => {
        if (that.itemBreadCrumb.length > 0) {
          let item = that.itemBreadCrumb[that.itemBreadCrumb.length - 1];
          let itemId = '';
          let driveId = '';
          if (item.extension === 'documentLibrary') {
            driveId = item.id;
          } else {
            itemId = item.id;
            driveId = item.parentReference.driveId;
          }
          if (driveId === itemId) {
            itemId = undefined;
          }
          that.isSaving = true;
          const ext = element.name.split('.').pop() || '';
          const tempId = that.addNewItemToGrid({
            id: 'pending_' + Date.now() + '_' + index,
            name: element.name,
            extension: ext,
            webUrl: '',
            modifiedDate: new Date().toISOString(),
            parentReference: { driveId: driveId },
            isSelected: false,
            isShow: true
          });
          // Track this upload so the cell renderer shows "Uploading…" until the
          // subscription returns. Keyed by _tempId since the placeholder's id
          // gets replaced with the real id on success.
          that.inFlightOps.set(tempId, 'upload');
          that._oneDriveService.uploadFile({ data: element, fileName: element.name } as FileParameter, driveId, itemId, 0).subscribe(result => {
            that.inFlightOps.delete(tempId);
            if (!result.isError && result.responseData) {
              if (removeOnSuccess) {
                // The file landed in a subfolder, not the current view — clear the
                // transient placeholder so it doesn't linger in this folder's list.
                that.removeItemFromGrid(tempId);
              } else {
                const uploadedItem = that.driveItems.find(i => i._tempId === tempId);
                if (uploadedItem) {
                  uploadedItem.id = result.responseData.id;
                  uploadedItem.name = result.responseData.name || element.name;
                  uploadedItem.webUrl = result.responseData.webUrl || '';
                  uploadedItem.parentReference = { driveId: result.responseData.driveId || driveId, siteId: result.responseData.siteId };
                  that._redrawRowFor(uploadedItem);
                }
              }
              fileCts--;
              if (fileCts <= 0) {
                this.isSaving = false;
                let options = that.toastrOptions;
                that.toastr.success(`${totalFiles === 1 ? 'File' : 'Files'} uploaded successfully.`, null, options);
              }
            } else {
              that.removeItemFromGrid(tempId);
              this.isSaving = false;
              if (result.errorMessage) {
                const errorDefinition = result.errorMessage ? AppConsts.oneDriveErrors[result.errorMessage] : {message: result.errorMessage};
                that._nsfEnqueueConflict(
                  errorDefinition,
                  `Couldn't upload this file`,
                  errorDefinition?.saveLabel ? () => {
                    that._oneDriveService.uploadFile({ data: element, fileName: element.name } as FileParameter, driveId, itemId, 1).subscribe(
                      retryResult => {
                        if (!retryResult.isError && retryResult.responseData) {
                          fileCts--;
                          if (fileCts <= 0) {
                            that.isSaving = false;
                            that.toastr.success(`${totalFiles === 1 ? 'File' : 'Files'} uploaded successfully.`, null, that.toastrOptions);
                          }
                          that.getDriveItems(that.selectedItem);
                        }
                      }
                    );
                  } : null,
                  () => {}
                );
              }
            }
          }, () => {
            that.inFlightOps.delete(tempId);
            that.removeItemFromGrid(tempId);
            this.isSaving = false;
            that.toastr.error(`Couldn't upload "${element.name}". Please try again.`, null, that.toastrOptions);
          });
        }
      });
    }
  }

  goToSpecificLevel(item) {
    if (item) {
      if (item.reqCallService) {
        if (item.reqCallService === 'getDrivesBySiteId') {
          this.goToDrivesBySiteId(item);
        }
      } else {
        if (item.extension === 'documentLibrary') {
          this.goToChildrenOfDrive(item);
        } else {
          this.getDriveItems(item);
        }
      }
    }
  }

  private searchTimeout: any;
  clearSearch() {
    this.searchText = '';
    this.applySearch();
  }

  applySearch() {
    const text = this.searchText.trim();
    if (this.level === 2) {
      // Libraries — filter locally
      if (this.drives.length > 0) {
        this.drives.forEach(element => {
          element.isShow = !text || element.name.toLowerCase().includes(text.toLowerCase());
        });
        this.checkIfItemsToShow();
      } else {
        this.noResultFound = false;
      }
      return;
    }

    // Level 1 — call API with searchText (debounced)
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (!text) {
      // Empty search — reload current folder
      if (this.selectedItem) {
        this.getDriveItems(this.selectedItem);
      }
      return;
    }

    // Show loading immediately while debouncing (don't clear existing data)
    this.showNsfGridLoading(false);

    this.searchTimeout = setTimeout(() => {
      if (!this.selectedItem) return;
      const driveId = this.selectedItem.parentReference?.driveId || this.selectedItem.driveId || this.selectedItem.id;
      const itemId = this.selectedItem.parentReference?.driveId === this.selectedItem.id ? undefined : this.selectedItem.id;
      this.isLoading = true;
      this.noResultFound = false;
      this.isFolderEmpty = false;
      this._oneDriveService.getMsFiles(driveId, itemId, undefined, text).subscribe(result => {
        this.isLoading = false;
        if (!result.isError && result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              element.isShow = true;
              element.isDisabled = false;
            });
            this.nextBatchLink = result.responseData['item2'] || '';
          } else {
            this.driveItems = [];
            this.noResultFound = true;
            this.nextBatchLink = '';
          }
        }
        this.updateNsfGridData();
      });
    }, 500);
  }

  private checkIfItemsToShow() {
    let noOfIsShowItems = 0;
    if (this.level === 1) {
      noOfIsShowItems = this.driveItems.filter(x => x.isShow).length;
    } else if (this.level === 2) {
      noOfIsShowItems = this.drives.filter(x => x.isShow).length;
    }
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  private initializeSearch() {
    this.noResultFound = false;
    this.searchText = '';
    $('.navigation-modal-search .input-group-append').hide();
    $('.navigation-modal-search .form-control').on('keyup blur', function (event) {
      setTimeout(() => {
        let divapp = $('.navigation-modal-search .input-group-append');
        if ($('.navigation-modal-search .form-control').val() !== '') {
          $(this).addClass('focus');
          divapp.show();
        } else {
          divapp.hide();
          $(this).removeClass('focus');
        }
      }, 50);
    });
    $('.navigation-modal-search .input-group-append').on('click', function () {
      $('.navigation-modal-search .form-control').trigger('focus');
      $(this).hide();
    });
  }

  removeSearch() {
    this.searchText = '';
    if (this.level === 1) {
      if (this.driveItems.length > 0) {
        this.driveItems.forEach(element => {
          element.isShow = true;
        });
        this.checkIfItemsToShow();
      } else {
        this.noResultFound = false;
      }
    } else {
      if (this.drives.length > 0) {
        this.drives.forEach(element => {
          element.isShow = true;
        });
        this.checkIfItemsToShow();
      } else {
        this.noResultFound = false;
      }
    }
  }

  openLink(item) {
    // let uriScheme = "";
    // switch (item.extension) {
    //     case '.docx':
    //     case '.doc':
    //         uriScheme = "ms-word:ofe|u|";
    //         break;
    //     case '.xlsx':
    //     case '.xls':
    //         uriScheme = "ms-excel:ofe|u|";
    //         break;
    //     case '.pptx':
    //     case '.ppt':
    //         uriScheme = "ms-powerpoint:ofe|u|";
    //         break;
    //     default:
    //         uriScheme = "";
    //         break;
    // }
    // let desktopLink = 'ms-word:ofe|u|' + item.webUrl;
    // window.location.href = desktopLink;
    // window.open(desktopLink, '_blank');
    window.open(item.webUrl, '_blank');
  }

  openInM365(item) {
    if (!item) {
      return;
    }

    // Prefer an embedded URL — works for any item that still carries its original payload
    // (initialItem, breadcrumb entries pushed via UI clicks, drives selected from the data source).
    const directUrl = item.webUrl || item.url || item.filePath;
    if (directUrl) {
      window.open(directUrl, '_blank');
      return;
    }

    // Folder / file: resolve via the Graph helper using driveId + itemId.
    if (item.parentReference && item.parentReference.driveId && item.id) {
      const isFile = item.extension && item.extension !== 'folder' && item.extension !== 'documentLibrary';
      this.getFileLocation(item.id, item.parentReference.driveId, isFile ? 2 : 1);
      return;
    }

    // Document library root: only the driveId is known. Use any currently-loaded child item's
    // parentReference.id (= drive root item id) and ask for its parent URL (requestType = 2).
    if (item.extension === 'documentLibrary' && item.id) {
      const driveId = item.id;
      const child = (this.driveItems || []).find(
        x => x && x.parentReference && x.parentReference.id && x.parentReference.driveId === driveId
      );
      if (child) {
        this.getFileLocation(child.id, driveId, 2);
        return;
      }
    }

    this.toastr.error('Unable to open this location in SharePoint.', null, this.toastrOptions);
  }

  openCurrentLocationInM365(): void {
    // Walk back through the breadcrumb to find the deepest entry that still carries a
    // direct URL (entries pushed via UI clicks always do; server-rebuilt entries from
    // getFolderBreadcrumb don't). Fall back to initialItem (which retains the original
    // payload from the caller) and finally to the last breadcrumb item.
    const withUrl = (i: any) => i && (i.webUrl || i.url || i.filePath);
    for (let i = this.itemBreadCrumb.length - 1; i >= 0; i--) {
      if (withUrl(this.itemBreadCrumb[i])) {
        this.openInM365(this.itemBreadCrumb[i]);
        return;
      }
    }
    if (withUrl(this.initialItem)) {
      this.openInM365(this.initialItem);
      return;
    }
    const last = this.itemBreadCrumb.length > 0
      ? this.itemBreadCrumb[this.itemBreadCrumb.length - 1]
      : this.initialItem;
    this.openInM365(last);
  }

  private getFileLocation(itemId, driveId, requestType = 2) {
    this._oneDriveService.getFileUrl(itemId, driveId, requestType).subscribe(result => {
      if (!result.isError) {
        if (result.responseData) {
          window.open(result.responseData, '_blank');
        }
      } else {
        const errorDef = result.errorMessage ? AppConsts.oneDriveErrors[result.errorMessage] : {message: result.errorMessage};
        this.errorTitle = "Couldn't open this location";
        this.currentError = errorDef;
        this.errorShell.show();
      }
    });
  }

  openAddToTask(item) {
    this.dataService.openFileToTaskModal.next([item, 'M365']);
  }

  addFileToCurrentTask(item) {
    const taskId = this._getCurrentTaskId();
    if (!taskId) {
      this.openAddToTask(item);
      return;
    }

    const input = new CommonAttachment();
    let isShareFile = true;

    if (item.parentReference && item.parentReference.driveType !== 'business') {
      isShareFile = false;
    }

    input.id = 0;
    input.entityId = taskId;
    input.entity = 22;
    input.webLink = item.webUrl;
    input.filePath = item.webUrl;
    input.fileName = item.name;
    input.fileType = item.extension ? item.extension : 'documentLibrary';
    input.keyId = item.id;
    input.isShareFile = item.parentReference ? isShareFile : false;
    input.isAddToShortcut = false;
    input.msDriveId = item.parentReference ? item.parentReference.driveId : item.driveId ? item.driveId : item.id;
    input.msSiteId = item.parentReference ? item.parentReference.siteId : item.siteId ? item.siteId : this.initialItem?.siteId;

    this._attachmentService.createOrUpdateAttachment(input).subscribe(result => {
      const options = this.toastrOptions;

      if (!result.isError) {
        this.dataService.refreshTaskAttachments.next(taskId);
        this.toastr.success('<b>"' + input.fileName + '"</b> is added to current task.', null, options);
        return;
      }

      if (result.errorMessage && result.errorMessage.toLocaleLowerCase() === 'duplicate') {
        this.toastr.error('Already added to current task.', null, options);
        return;
      }

      this.toastr.error(result.errorMessage || 'Error while adding file to current task.', null, options);
    });
  }

  openLinkToProject(item) {
    this.dataService.openFileToProjectModal.next([item, 'M365']);
  }

  addFileTaskToMyDay(item, isDocLibrary, sectionId?: number) {
    let input = new CreateFileTask();
    input.code = 111;
    input.entity = 0;
    input.entityId = 0;
    input.id = 0;
    input.keyId = item.id;
    input.filePath = item.webUrl;
    input.fileName = item.name;
    input.fileType = isDocLibrary ? 'documentLibrary' : item.extension;
    input.webLink = item.webUrl;
    input.isLink = false;
    input.isShareFile = false;
    input.isAddToShortcut = false;
    input.msDriveId = item.parentReference ? item.parentReference.driveId : item.id;
    input.msSiteId = item.parentReference ? item.parentReference.siteId : (isDocLibrary ? this.initialItem.id : null);
    input.msFolderId = item.folderId ? item.folderId : '';
    input.startDate = null;
    input.userSectionId = sectionId ? sectionId : 0;
    // If mine.component is listening, use the subject (it will create the task)
    if (this.dataService.addFileTaskToAgenda.observers.length > 0) {
      this.dataService.addFileTaskToAgenda.next(input);
    } else {
      // Otherwise call the service directly
      this._taskService.createFileTask(input).subscribe(result => {
        if (!result.isError) {
          let options = this.toastrOptions;
          this.toastr.success('<b>"' + input.fileName + '"</b> is added to my day.', null, options);
        }
      });
    }
  }

  addFileTaskToDoLater(item, isDocLibrary) {
    let input = new CreateFileTask();
    input.code = 121;
    input.entity = 0;
    input.entityId = 0;
    input.id = 0;
    input.keyId = item.id;
    input.filePath = item.webUrl;
    input.fileName = item.name;
    input.fileType = isDocLibrary ? 'documentLibrary' : item.extension;
    input.webLink = item.webUrl;
    input.isLink = false;
    input.isShareFile = false;
    input.isAddToShortcut = false;
    input.msDriveId = item.parentReference ? item.parentReference.driveId : item.id;
    input.msSiteId = item.parentReference ? item.parentReference.siteId : (isDocLibrary ? this.initialItem.id : null);
    input.msFolderId = item.folderId ? item.folderId : '';
    input.startDate = null;
    this.dataService.openDoLaterModal.next(input);
  }

  openShareLinkModal(item: any) {
    let input = cloneDeep(item);
    input.fileId = cloneDeep(item.id);
    input.driveId = cloneDeep(item.parentReference.driveId);
    this.dataService.openShareFileModal.next(input);
  }

  openRenameFileModal(item: any, isDocLibrary) {
    let input = cloneDeep(item);
    input.type = 0;
    input.siteId = !isDocLibrary ? cloneDeep(item.parentReference.siteId) : this.initialItem.id;
    input.fileName = cloneDeep(item.name);
    input.driveId = !isDocLibrary ? cloneDeep(item.parentReference.driveId) : item.id;
    input.fileId = cloneDeep(item.id);
    input.id = 0;
    input.extension = isDocLibrary ? 'documentLibrary' : item.extension;
    this.dataService.openRenameFileModal.next(input);
  }

  okFileBtnClick(ev: any): void {
    if (ev.toggle) {
      if (ev.obj) {
        this.deleteFile(ev.obj);
      }
    }
    this.delFileItem = undefined;
  }

  deleteFile(item): void {
    const isLibrary = (item.extension || '').toLowerCase() === 'documentlibrary';
    // Library rows live in `drives` (the site level); files and folders in `driveItems` — see
    // updateNsfGridData, which picks the array by level. Splicing the wrong one would drop a
    // different row from the grid than the one being deleted.
    const rows = isLibrary ? this.drives : this.driveItems;

    // remove file object from array
    let idx = rows.findIndex(x => x.id === item.id);
    if (idx > -1) {
      rows.splice(idx, 1);
    }
    this.updateNsfGridData();

    // A library is not a driveItem — it has no containing item, because the library IS its drive —
    // so deleteMsFile cannot address it, and `parentReference` is absent on those rows anyway.
    const request = isLibrary
      ? this._oneDriveService.deleteDocumentLibrary(item.id, item.msSiteId || item.siteId, item.name)
      : this._oneDriveService.deleteMsFile(item.id, item.parentReference.driveId);

    request.subscribe((result) => {
        if (!result.isError) {
          let options = this.toastrOptions;
          this.toastr.success('<b>' + item.name + '</b> deleted successfully.<br>', null, options);
        } else {
          if (result.errorMessage === '103') {
            this.information = 'You do not have the necessary permissions to delete files/folders in this location. Please choose a different destination or contact your administrator for access.';
            this.isShowInfoPopup = true;
          }
          // Re-add item back if delete failed. Guard the index: findIndex returns -1 when the row
          // was never in the array, and splice(-1, 0, item) would silently insert it second-to-last.
          if (idx > -1) {
            rows.splice(idx, 0, item);
            this.updateNsfGridData();
          }
        }
      });
  }

  /** A row here is a Graph drive item, so it gets its own attachment row and that is what is pinned. */
  addFilesToShortcut(linkitem, isDocLibrary) {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    const parent = linkitem.parentReference;

    const attachment = new CommonAttachment();
    // A favorited file belongs to nothing else, so it hangs off the user.
    attachment.entity = LookUpTables._25; // AllUserIncludeMe
    attachment.entityId = this.appSession.userId;
    attachment.id = 0;
    attachment.fileName = linkitem.name;
    attachment.filePath = linkitem.webUrl;
    attachment.webLink = linkitem.webUrl;
    attachment.fileType = isDocLibrary
      ? 'documentLibrary'
      : (linkitem.folder && !linkitem.file ? 'folder' : linkitem.extension);
    attachment.keyId = linkitem.id;
    attachment.msDriveId = parent ? parent.driveId : linkitem.id;
    attachment.msSiteId = parent ? parent.siteId : (isDocLibrary ? this.initialItem.id : null);
    attachment.msFolderId = parent ? parent.id : null;
    attachment.isLink = false;
    attachment.isShareFile = false;
    attachment.isAddToShortcut = false;
    attachment.isDefault = false;

    this._attachmentService.createAttachment(attachment).pipe(
      switchMap(created => {
        if (created.isError || !created.responseData) {
          return of({ isError: true, errorMessage: created.errorMessage });
        }
        const favorite = new AddFavoriteInput();
        favorite.entityId = created.responseData;
        favorite.type = EntityType._8; // Attachment
        return this._favoriteService.addFavorite(favorite).pipe(
          map(res => ({ isError: res.isError, errorMessage: res.errorMessage })));
      })
    ).subscribe(result => {
      this.isSaving = false;
      if (!result.isError) {
        let options = this.toastrOptions;
        this.toastr
          .success('Added to favorites.',
            null, options);
        this.dataService.refreshShortcuts.next({ skipModal: true });
      } else {
        if (result.errorMessage?.toLocaleLowerCase() === 'duplicate') {
          let options = this.toastrOptions;
          this.toastr
            .error('Already added to favorites.',
              null, options);
        } else {
          let options = this.toastrOptions;
          this.toastr
            .error('Error while adding to favorites.',
              null, options);
        }
      }
    });
  }

  showSelectAll() {
    this.isShowSelectAll = !this.isShowSelectAll;
  }

  hideSelectAllBar() {
    this.isShowSelectAll = false;
    this.isAllItemsSelected = false;
    this.assignIsSelectedToDriveItems();
    this.noOfSelectedItems = 0;
    if (this.nsfGridApi) {
      this.nsfGridApi.deselectAll();
    }
  }

  updateNsfColumnVisibility() {
    if (!this.nsfColumnApi) return;
    this.nsfColumnApi.setColumnVisible('selection', this.isShowSelectAll);
    if (this.nsfGridApi) {
      this.nsfGridApi.deselectAll();
      setTimeout(() => {
        if (this.nsfGridApi) this.nsfGridApi.sizeColumnsToFit();
      }, 50);
    }
  }

  selectItem(item) {
    this.isAllItemsSelected = false;
    item.isSelected = !item.isSelected;
    this.noOfSelectedItems = this.driveItems.filter(x => x.isSelected).length;
  }

  selectAllItems() {
    this.isAllItemsSelected = !this.isAllItemsSelected;
    this.assignIsSelectedToDriveItems();
    this.noOfSelectedItems = this.driveItems.filter(x => x.isSelected).length;
  }

  clearAllSelectedItems() {
    this.isAllItemsSelected = false;
    this.assignIsSelectedToDriveItems();
    this.noOfSelectedItems = 0;
    if (this.nsfGridApi) {
      this.nsfGridApi.deselectAll();
    }
  }

  private assignIsSelectedToDriveItems() {
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        element.isSelected = this.isAllItemsSelected;
      });
    }
  }

  moveWithinThisFolder(item?) {
    if (item) {
      let input = new Array<any>();
      let data = {
        selectedLocation: this.itemBreadCrumb[this.itemBreadCrumb.length - 1],
        items: input,
        type: 'moveWithin'
      }
      let obj = {
        id: item.id,
        driveId: item.parentReference.driveId,
        fileId: item.id,
        siteId: item.parentReference.siteId,
        name: item.name,
        extension: item.extension
      };
      input.push(obj);
      this.dataService.openCopyOrMovePopup.next(data);
    } else {
      let selectedItems = this.driveItems.filter(x => x.isSelected);
      if (selectedItems.length > 0) {
        let input = new Array<any>();
        let data = {
          selectedLocation: this.itemBreadCrumb[this.itemBreadCrumb.length - 1],
          items: input,
          type: 'moveWithin'
        }
        selectedItems.forEach(element => {
          let obj = {
            id: element.id,
            driveId: element.parentReference.driveId,
            fileId: element.id,
            siteId: element.parentReference.siteId,
            name: element.name,
            extension: element.extension
          };
          input.push(obj);
        });
        this.dataService.openCopyOrMovePopup.next(data);
      } else {
        let options = this.toastrOptions;
        this.toastr
          .error('Please select at least one item to move.',
            null, options);
      }
    }
  }

  moveToDiffLocation(item?) {
    if (item) {
      let input = new Array<any>();
      let data = {
        selectedLocation: null,
        items: input,
        type: 'move'
      }
      let obj = {
        id: item.id,
        driveId: item.parentReference.driveId,
        fileId: item.id,
        siteId: item.parentReference.siteId,
        name: item.name,
        extension: item.extension
      };
      input.push(obj);
      this.dataService.openCopyOrMovePopup.next(data);
    } else {
      let selectedItems = this.driveItems.filter(x => x.isSelected);
      if (selectedItems.length > 0) {
        let input = new Array<any>();
        let data = {
          selectedLocation: null,
          items: input,
          type: 'move'
        }
        selectedItems.forEach(element => {
          let obj = {
            id: element.id,
            driveId: element.parentReference.driveId,
            fileId: element.id,
            siteId: element.parentReference.siteId,
            name: element.name,
            extension: element.extension
          };
          input.push(obj);
        });
        this.dataService.openCopyOrMovePopup.next(data);
      } else {
        let options = this.toastrOptions;
        this.toastr
          .error('Please select at least one item to move.',
            null, options);
      }
    }
  }

  copyWithinThisFolder(item?) {
    if (item) {
      let input = new Array<any>();
      let data = {
        selectedLocation: this.itemBreadCrumb[this.itemBreadCrumb.length - 1],
        items: input,
        type: 'copyWithin'
      }
      let obj = {
        id: item.id,
        driveId: item.parentReference.driveId,
        fileId: item.id,
        siteId: item.parentReference.siteId,
        name: item.name,
        extension: item.extension
      };
      input.push(obj);
      this.dataService.openCopyOrMovePopup.next(data);
    } else {
      let selectedItems = this.driveItems.filter(x => x.isSelected);
      if (selectedItems.length > 0) {
        let input = new Array<any>();
        let data = {
          selectedLocation: this.itemBreadCrumb[this.itemBreadCrumb.length - 1],
          items: input,
          type: 'copyWithin'
        }
        selectedItems.forEach(element => {
          let obj = {
            id: element.id,
            driveId: element.parentReference.driveId,
            fileId: element.id,
            siteId: element.parentReference.siteId,
            name: element.name,
            extension: element.extension
          };
          input.push(obj);
        });
        this.dataService.openCopyOrMovePopup.next(data);
      } else {
        let options = this.toastrOptions;
        this.toastr
          .error('Please select at least one item to copy.',
            null, options);
      }
    }
  }

  copyToDiffLocation(item?) {
    if (item) {
      let input = new Array<any>();
      let data = {
        selectedLocation: null,
        items: input,
        type: 'copy'
      }
      let obj = {
        id: item.id,
        driveId: item.parentReference.driveId,
        fileId: item.id,
        siteId: item.parentReference.siteId,
        name: item.name,
        extension: item.extension
      };
      input.push(obj);
      this.dataService.openCopyOrMovePopup.next(data);
    } else {
      let selectedItems = this.driveItems.filter(x => x.isSelected);
      if (selectedItems.length > 0) {
        let input = new Array<any>();
        let data = {
          selectedLocation: null,
          items: input,
          type: 'copy'
        }
        selectedItems.forEach(element => {
          let obj = {
            id: element.id,
            driveId: element.parentReference.driveId,
            fileId: element.id,
            siteId: element.parentReference.siteId,
            name: element.name,
            extension: element.extension
          };
          input.push(obj);
        });
        this.dataService.openCopyOrMovePopup.next(data);
      } else {
        let options = this.toastrOptions;
        this.toastr
          .error('Please select at least one item to copy.',
            null, options);
      }
    }
  }

  deleteSelectedItems() {
    let selectedItems = this.driveItems.filter(x => x.isSelected);
    if (selectedItems.length > 0) {
      this.noOfSelectedItems = selectedItems.length;
      this.deleteMultipleFilesDeletePopup.show();
      this.updateBodyForCenterModalShow();
    } else {
      let options = this.toastrOptions;
      this.toastr
        .error('Please select at least one item to delete.',
          null, options);
    }
  }

  closeMultipleFileDeletePopup() {
    this.deleteMultipleFilesDeletePopup.hide();
    this.updateBodyForCenterModalHide();
  }

  deleteMultipleFiles() {
    let selectedItems = this.driveItems.filter(x => x.isSelected);
    if (selectedItems.length > 0) {
      this.isDeleting = true;
      selectedItems.forEach(element => {
        let obj = {
          id: element.id,
          driveId: element.parentReference.driveId,
          fileId: element.id,
          siteId: element.parentReference.siteId,
          name: element.name,
          extension: element.extension
        };
        this._oneDriveService.deleteMsFile(obj.fileId, obj.driveId).subscribe(result => {
          if (!result.isError) {
            if (this.noOfSelectedItems === selectedItems.length) {
              this.isDeleting = false;
              let options = this.toastrOptions;
              this.toastr
                .success('Selected items deleted successfully.',
                  null, options);
              this.deleteMultipleFilesDeletePopup.hide();
              this.updateBodyForCenterModalHide();
              if (this.selectedItem.extension === 'documentLibrary') {
                this.goToChildrenOfDrive(this.selectedItem);
              } else {
                this.getDriveItems(this.selectedItem);
              }
            }
          } else {
            this.isDeleting = false;
            if (result.errorMessage === '103') {
              this.information = 'You do not have the necessary permissions to delete files/folders in this location. Please choose a different destination or contact your administrator for access.';
              this.isShowInfoPopup = true;
            } else {
              let options = this.toastrOptions;
              this.toastr
                .error('Error while deleting selected items.',
                  null, options);
            }
            if (this.selectedItem.extension === 'documentLibrary') {
              this.goToChildrenOfDrive(this.selectedItem);
            } else {
              this.getDriveItems(this.selectedItem);
            }
          }
        });
      });
    }
  }

  onNewLibKeyPress(event: any): boolean {
    if (event.keyCode === 13) {
      this.createLibrary(event);
    }
    return event.keyCode !== 13;
  }

  onNewLibBlur(event: any) {
    let value: string = event.target.innerText.trim();
    if (value.length === 0) {
      this.isShowAddLibrary = false;
      return;
    }
    this.createLibrary(event);
  }

  private createLibrary(event) {
    let value: string = event.target.innerText.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    this.isSaving = true;
    let input: CreateFolderDto = new CreateFolderDto();
    input.name = value;
    input.siteId = this.initialItem.id;
    const userName = this.appSession.user
      ? ((this.appSession.user.name || '') + ' ' + (this.appSession.user.surname || '')).trim()
      : '';
    const tempLib = {
      id: 'pending_' + Date.now(),
      _tempId: 'temp_lib_' + Date.now(),
      name: input.name,
      extension: 'documentLibrary',
      webUrl: '',
      modifiedDate: new Date().toISOString(),
      modifiedBy: userName,
      isSelected: false,
      isShow: true
    };
    this.drives.unshift(tempLib);
    if (this.nsfGridApi) {
      this.nsfGridApi.applyTransaction({ add: [tempLib], addIndex: 0 });
    }
    this.isShowAddLibrary = false;
    event.target.innerText = '';
    this._oneDriveService.createDocumentLibrary(input).subscribe(result => {
      this.isSaving = false;
      if (!result.isError && result.responseData) {
        tempLib.id = result.responseData.driveId || result.responseData.folderId;
        tempLib.webUrl = result.responseData.folderUrl || '';
        let options = this.toastrOptions;
        this.toastr.success('Library created successfully.', null, options);
      } else {
        // Remove optimistic item on error
        const idx = this.drives.findIndex(d => d._tempId === tempLib._tempId);
        if (idx > -1) {
          const removed = this.drives.splice(idx, 1);
          if (this.nsfGridApi) this.nsfGridApi.applyTransaction({ remove: removed });
        }
        let options = this.toastrOptions;
        this.toastr.error('Error while creating library.', null, options);
      }
    });
  }

  showAddLibrary() {
    this.isShowAddLibrary = true;
    setTimeout(() => {
      const el = document.querySelector('.create-library') as HTMLElement;
      if (el) el.focus();
    }, 100);
  }

  showSubmenu(submenuName: string) {
    this.activeSubmenu = submenuName;
  }

  hideSubmenu(submenuName: string) {
    setTimeout(() => {
      if (this.activeSubmenu === submenuName) {
        this.activeSubmenu = null;
      }
    }, 100);
  }

  getUserSections() {
    // this._agendaService.getUserSections().subscribe(result => {
    //   if (!result.isError) {
    //     this.userSectionData = result.responseData;
    //   }
    // });
  }

  closeNestedDropdown(): void {
    if (this.nestedDropdown && this.nestedDropdown.isOpen) {
      this.nestedDropdown.hide();
    }
  }

  closeCopyDropdown(): void {
    if (this.copyDropdown && this.copyDropdown.isOpen) {
      this.copyDropdown.hide();
    }
  }

  closeMoveDropdown(): void {
    if (this.moveDropdown && this.moveDropdown.isOpen) {
      this.moveDropdown.hide();
    }
  }

  private _nsfEnqueueConflict(
    error: { message: string; cancelLabel?: string; saveLabel?: string },
    title: string,
    onSaveAnyway: (() => void) | null,
    onCancel: () => void
  ): void {
    this._nsfConflictQueue.push({ error, title, onSaveAnyway, onCancel });
    if (!this._nsfConflictQueueActive) {
      this._nsfDequeueConflict();
    }
  }

  private _nsfDequeueConflict(): void {
    if (this._nsfConflictQueue.length === 0) {
      this._nsfConflictQueueActive = false;
      return;
    }
    this._nsfConflictQueueActive = true;
    const next = this._nsfConflictQueue.shift()!;
    this.currentError = next.error;
    this.errorTitle = next.title;
    this._nsfConflictQueueCurrent = { onSaveAnyway: next.onSaveAnyway, onCancel: next.onCancel };
    this.errorShell.show();
  }

  private _nsfDequeueMoveConflict(): void {
    if (this._nsfMoveConflictQueue.length === 0) {
      this._nsfMoveConflictActive = false;
      return;
    }
    this._nsfMoveConflictActive = true;
    const next = this._nsfMoveConflictQueue.shift()!;
    this._nsfMoveConflictCurrent = next;
    this._nsfLastErrorCode = next.errorCode;
    this.errorTitle = "Couldn't move this file";
    this.currentError = AppConsts.oneDriveErrors[next.errorCode] ?? { message: next.errorCode };
    this.errorShell.show();
  }

  private _nsfAskConflict(errorMessage: string, title: string): Promise<boolean> {
    const errorDefinition = AppConsts.oneDriveErrors[errorMessage] ?? {message: errorMessage};
    this.currentError = errorDefinition;
    this.errorTitle = title;
    this.nsfConflictedUpload = null;
    this.nsfUploadFinishCallback = null;
    return new Promise<boolean>(resolve => {
      this._nsfFolderConflictResolve = resolve;
      this.errorShell.show();
    });
  }

  closeError(): void {
    this.errorShell.hide();
    this.currentError = undefined;
    this._nsfLastErrorCode = null;
    if (this._nsfMoveConflictCurrent) {
      const current = this._nsfMoveConflictCurrent;
      this._nsfMoveConflictCurrent = null;
      current.onFinish();
      this._nsfDequeueMoveConflict();
      return;
    }
    if (this._nsfFolderConflictResolve) {
      const resolve = this._nsfFolderConflictResolve;
      this._nsfFolderConflictResolve = null;
      resolve(false);
      return;
    }
    this._nsfPendingFolderInput = null;
    this._nsfPendingFileInput = null;
    if (this._nsfConflictQueueCurrent) {
      const current = this._nsfConflictQueueCurrent;
      this._nsfConflictQueueCurrent = null;
      current.onCancel();
      this._nsfDequeueConflict();
      return;
    }
    if (this.nsfUploadFinishCallback) {
      const callback = this.nsfUploadFinishCallback;
      this.nsfConflictedUpload = null;
      this.nsfUploadFinishCallback = null;
      callback(false);
    }
  }

  saveError(): void {
    this.errorShell.hide();
    if (this._nsfFolderConflictResolve) {
      const resolve = this._nsfFolderConflictResolve;
      this._nsfFolderConflictResolve = null;
      resolve(true);
      return;
    }
    if (this._nsfConflictQueueCurrent) {
      const current = this._nsfConflictQueueCurrent;
      this._nsfConflictQueueCurrent = null;
      if (current.onSaveAnyway) { current.onSaveAnyway(); }
      this._nsfDequeueConflict();
      return;
    }
    if (this._nsfPendingFolderInput) {
      const retryInput = this._nsfPendingFolderInput;
      this._nsfPendingFolderInput = null;
      const doCreateFolder = () => {
        this.isSaving = true;
        const newTempId = this.addNewItemToGrid({
          id: 'pending_' + Date.now(),
          name: retryInput.name,
          extension: 'folder',
          webUrl: '',
          modifiedDate: new Date().toISOString(),
          parentReference: { driveId: retryInput.driveId },
          folder: { childCount: 0 },
          isSelected: false,
          isShow: true
        });
        this.inFlightOps.set(newTempId, 'create');
        this._oneDriveService.createFolder(retryInput).subscribe(result => {
          this.isSaving = false;
          this.inFlightOps.delete(newTempId);
          if (!result.isError && result.responseData) {
            const item = this.driveItems.find(i => i._tempId === newTempId);
            if (item) {
              item.id = result.responseData.folderId || result.responseData.driveId;
              item.webUrl = result.responseData.folderUrl || '';
              item.parentReference = { driveId: result.responseData.driveId || retryInput.driveId, siteId: result.responseData.siteId };
              this._redrawRowFor(item);
            }
            this.toastr.success('Folder created successfully.', null, this.toastrOptions);
          } else {
            this.removeItemFromGrid(newTempId);
            if (result.errorMessage) {
              const errDef = AppConsts.oneDriveErrors[result.errorMessage] ?? {message: result.errorMessage};
              this.currentError = errDef;
              this._nsfLastErrorCode = result.errorMessage;
              this.errorTitle = `Couldn't create this folder`;
              if (errDef?.saveLabel) { this._nsfPendingFolderInput = retryInput; }
              this.errorShell.show();
            }
          }
        }, () => {
          this.isSaving = false;
          this.inFlightOps.delete(newTempId);
          this.removeItemFromGrid(newTempId);
        });
      };
      if (this._nsfLastErrorCode === '101') {
        this.dataService.openRenameFileModal.next({ fileName: retryInput.name, skipRenameCall: true, extension: 'folder' });
        this.dataService.copyMoveRenameResult.pipe(take(1)).subscribe(newName => {
          if (!newName) { return; }
          retryInput.name = newName;
          retryInput.isUseExisting = false;
          doCreateFolder();
        });
      } else if (this._nsfLastErrorCode === '106' || this._nsfLastErrorCode === '107' || this._nsfLastErrorCode === '114') {
        retryInput.isUseExisting = false;
        doCreateFolder();
      }
      return;
    }
    if (this._nsfPendingFileInput) {
      const retryInput = this._nsfPendingFileInput;
      this._nsfPendingFileInput = null;
      if (this._nsfLastErrorCode === '101') {
        this.dataService.openRenameFileModal.next({
          fileName: retryInput.name + (retryInput.extension || ''),
          skipRenameCall: true,
        });
        this.dataService.copyMoveRenameResult.pipe(take(1)).subscribe(newName => {
          if (!newName) { return; }
          const ext = retryInput.extension || '';
          retryInput.name = (ext && newName.endsWith(ext)) ? newName.slice(0, -ext.length) : newName;
          retryInput.duplicateAction = 0;
          this.isSaving = true;
          const extStr = ext.replace('.', '');
          const rNewTempId = this.addNewItemToGrid({
            id: 'pending_' + Date.now(),
            name: retryInput.name + ext,
            extension: extStr,
            webUrl: '',
            modifiedDate: new Date().toISOString(),
            parentReference: { driveId: retryInput.driveId },
            isSelected: false,
            isShow: true
          });
          this.inFlightOps.set(rNewTempId, 'create');
          this._oneDriveService.createOneDriveFile(retryInput).subscribe(result => {
            this.isSaving = false;
            this.inFlightOps.delete(rNewTempId);
            if (!result.isError && result.responseData) {
              const newItem = this.driveItems.find(i => i._tempId === rNewTempId);
              if (newItem) {
                newItem.id = result.responseData.keyId;
                newItem.name = result.responseData.fileName || newItem.name;
                newItem.webUrl = result.responseData.url;
                newItem.parentReference = { driveId: result.responseData.driveId || retryInput.driveId, siteId: result.responseData.siteId };
                this._redrawRowFor(newItem);
              }
              this.toastr.success('File created successfully.', null, this.toastrOptions);
            } else {
              this.removeItemFromGrid(rNewTempId);
              if (result.errorMessage) {
                const errDef = AppConsts.oneDriveErrors[result.errorMessage] ?? {message: result.errorMessage};
                this.currentError = errDef;
                this._nsfLastErrorCode = result.errorMessage;
                this.errorTitle = `Couldn't create this file`;
                if (errDef?.saveLabel) { this._nsfPendingFileInput = retryInput; }
                this.errorShell.show();
              }
            }
          }, () => {
            this.isSaving = false;
            this.inFlightOps.delete(rNewTempId);
            this.removeItemFromGrid(rNewTempId);
          });
        });
        return;
      }
      if (this._nsfLastErrorCode === '106' || this._nsfLastErrorCode === '107' || this._nsfLastErrorCode === '114') {
        retryInput.duplicateAction = 0;
        this.isSaving = true;
        const ext = retryInput.extension ? retryInput.extension.replace('.', '') : '';
        const newTempId = this.addNewItemToGrid({
          id: 'pending_' + Date.now(),
          name: retryInput.name + (retryInput.extension || ''),
          extension: ext,
          webUrl: '',
          modifiedDate: new Date().toISOString(),
          parentReference: { driveId: retryInput.driveId },
          isSelected: false,
          isShow: true
        });
        this.inFlightOps.set(newTempId, 'create');
        this._oneDriveService.createOneDriveFile(retryInput).subscribe(result => {
          this.isSaving = false;
          this.inFlightOps.delete(newTempId);
          if (!result.isError && result.responseData) {
            const item = this.driveItems.find(i => i._tempId === newTempId);
            if (item) {
              item.id = result.responseData.keyId;
              item.name = result.responseData.fileName || item.name;
              item.webUrl = result.responseData.url;
              item.parentReference = { driveId: result.responseData.driveId || retryInput.driveId, siteId: result.responseData.siteId };
              this._redrawRowFor(item);
            }
            this.toastr.success('File created successfully.', null, this.toastrOptions);
          } else {
            this.removeItemFromGrid(newTempId);
          }
        }, () => {
          this.isSaving = false;
          this.inFlightOps.delete(newTempId);
          this.removeItemFromGrid(newTempId);
        });
      }
      return;
    }
    if (this._nsfMoveConflictCurrent) {
      const current = this._nsfMoveConflictCurrent;
      this._nsfMoveConflictCurrent = null;
      if (this._nsfLastErrorCode === '101') {
        this.dataService.openRenameFileModal.next({ fileName: current.itemName, skipRenameCall: true });
        this.dataService.copyMoveRenameResult.pipe(take(1)).subscribe(newName => {
          if (newName) { current.onRetry(newName); } else { current.onFinish(); }
          this._nsfDequeueMoveConflict();
        });
      } else if (this._nsfLastErrorCode === '106' || this._nsfLastErrorCode === '107' || this._nsfLastErrorCode === '114') {
        current.onRetry();
        this._nsfDequeueMoveConflict();
      } else {
        current.onFinish();
        this._nsfDequeueMoveConflict();
      }
      return;
    }
    if (this.nsfConflictedUpload) {
      const { file, driveId, keyId } = this.nsfConflictedUpload;
      const callback = this.nsfUploadFinishCallback!;
      this.nsfConflictedUpload = null;
      this.nsfUploadFinishCallback = null;
      this._oneDriveService.uploadFile({ data: file, fileName: file.name } as FileParameter, driveId, keyId, 1).subscribe(
        result => { callback(!result.isError && !!result.responseData); },
        () => { callback(false); }
      );
    }
  }

}
